(function () {
  'use strict';
  /* =========================================================================
     THE A METHOD® ROUTINE BUILDER — APPLICATION SCRIPT
     Everything below is wrapped in one IIFE. Nothing is added to window.
     ======================================================================= */

  var ROOT = document.getElementById('am-routine-builder');
  if (!ROOT) { return; }

  /* =========================================================================
     BRAND SETTINGS
     Text used across the experience + download card. Edit freely.
     ======================================================================= */
  var AMRB_BRAND = {
    name: 'THE A METHOD®',
    site: 'theamethod.com',
    resultTitle: 'MY METHOD',
    resultTagline: 'Your skin. Your goals. Your method.',
    storageKey: 'amrb_routine_v1',
    /* QR code on the downloadable / printable routine card.
       The /discount/ link is a standard Shopify URL that auto-applies the
       code at checkout, then lands the shopper on the storefront. */
    qrUrl: 'https://theamethod.com/discount/MYMETHOD',
    promoCode: 'MYMETHOD',
    promoLine1: 'Scan to shop your recommendations',
    promoLine2: '30% off your next product purchase',
    disclaimer: 'This guide is intended for skincare education and does not replace individualized medical advice. Follow instructions from your dermatologist or treating provider for prescription products, medical skin conditions, and post-procedure care.'
  };

  /* =========================================================================
     LAYERING RULES
     The canonical order of a routine. `key` values are referenced throughout
     the engine — edit labels/explanations freely, keys carefully.
     ======================================================================= */
  var AMRB_LAYERS = [
    { key: 'cleanse',    label: 'Cleanse',    am: true,  pm: true,
      why: 'Every routine starts on clean skin. Cleansing removes oil, sunscreen, and environmental debris so the products that follow can actually reach the skin instead of sitting on top of it.' },
    { key: 'prep',       label: 'Prep',       am: true,  pm: true,
      why: 'Toners, pads, and essences are the thinnest layers in a routine. Applied right after cleansing, they balance the skin and help follow-up products absorb more evenly.' },
    { key: 'treat',      label: 'Treat',      am: true,  pm: true,
      why: 'Concentrated serums and actives go on early, while skin is most receptive. Antioxidants like vitamin C typically belong in the morning; renewal actives like retinol belong at night.' },
    { key: 'hydrate',    label: 'Hydrate',    am: true,  pm: true,
      why: 'Water-based hydrators such as hyaluronic acid draw moisture into the skin. They sit between treatments and moisturizer — thin enough to absorb, essential for plumpness and comfort.' },
    { key: 'moisturize', label: 'Moisturize', am: true,  pm: true,
      why: 'Moisturizer is the seal. Applied after serums have absorbed, it locks in hydration and supports the skin barrier — which matters even more when a routine contains actives.' },
    { key: 'eye',        label: 'Eye Care',   am: true,  pm: true,
      why: 'The skin around the eyes is the thinnest on the face. Dedicated eye formulas are applied with light pressure near the end of the routine, after treatments and moisturizer.' },
    { key: 'protect',    label: 'Protect',    am: true,  pm: false,
      why: 'SPF is always the final skincare step of the morning — it needs to sit on top to shield skin from UV, the single biggest driver of visible aging and uneven tone.' }
  ];

  /* AM display order and PM display order by layer key */
  var AMRB_AM_ORDER = ['cleanse', 'prep', 'treat', 'hydrate', 'moisturize', 'eye', 'protect'];
  var AMRB_PM_ORDER = ['cleanse', 'prep', 'treat', 'hydrate', 'moisturize', 'eye'];

  /* =========================================================================
     PRODUCT TYPES (for the "what's on your shelf" form)
     slot: which layer the type maps to
     actives: ingredient tags safely inferred from the category alone
     am/pm: default placement (may be overridden by COMPATIBILITY RULES)
     ======================================================================= */
  var AMRB_TYPES = [
    { id: 'cleanser',        label: 'Cleanser',                 slot: 'cleanse',    am: true,  pm: true,  actives: [] },
    { id: 'toner',           label: 'Toner',                    slot: 'prep',       am: true,  pm: true,  actives: [] },
    { id: 'prep-pad',        label: 'Prep / treatment pad',     slot: 'prep',       am: true,  pm: true,  actives: [] },
    { id: 'essence',         label: 'Essence',                  slot: 'prep',       am: true,  pm: true,  actives: [] },
    { id: 'vitamin-c',       label: 'Vitamin C serum',          slot: 'treat',      am: true,  pm: false, actives: ['vitamin-c'] },
    { id: 'hydrating-serum', label: 'Hydrating serum',          slot: 'hydrate',    am: true,  pm: true,  actives: [] },
    { id: 'treatment-serum', label: 'Treatment serum',          slot: 'treat',      am: true,  pm: true,  actives: [] },
    { id: 'peptide-serum',   label: 'Peptide serum',            slot: 'treat',      am: true,  pm: true,  actives: ['peptides'] },
    { id: 'exosome-serum',   label: 'Exosome serum',            slot: 'treat',      am: false, pm: true,  actives: ['exosomes'] },
    { id: 'retinol',         label: 'Retinol / retinoid',       slot: 'treat',      am: false, pm: true,  actives: ['retinol'] },
    { id: 'exfoliant',       label: 'AHA / BHA / exfoliant',    slot: 'treat',      am: false, pm: true,  actives: ['aha-bha'] },
    { id: 'acne',            label: 'Acne treatment',           slot: 'treat',      am: true,  pm: true,  actives: [] },
    { id: 'eye-treatment',   label: 'Eye treatment',            slot: 'eye',        am: true,  pm: true,  actives: [] },
    { id: 'moisturizer',     label: 'Moisturizer',              slot: 'moisturize', am: true,  pm: true,  actives: [] },
    { id: 'face-oil',        label: 'Face oil',                 slot: 'moisturize', am: false, pm: true,  actives: [] },
    { id: 'sunscreen',       label: 'Sunscreen',                slot: 'protect',    am: true,  pm: false, actives: ['spf'] },
    { id: 'mask',            label: 'Mask',                     slot: 'weekly',     am: false, pm: true,  actives: [] },
    { id: 'other',           label: 'Other',                    slot: 'treat',      am: true,  pm: true,  actives: [] }
  ];

  /* Optional ingredient tags a user can attach to a shelf product */
  var AMRB_ACTIVE_TAGS = [
    { id: 'retinol',          label: 'Retinol / retinoid' },
    { id: 'vitamin-c',        label: 'Vitamin C' },
    { id: 'exosomes',         label: 'Exosomes' },
    { id: 'peptides',         label: 'Peptides' },
    { id: 'aha-bha',          label: 'AHA / BHA acids' },
    { id: 'benzoyl-peroxide', label: 'Benzoyl peroxide' },
    { id: 'hyaluronic-acid',  label: 'Hyaluronic acid' },
    { id: 'niacinamide',      label: 'Niacinamide' },
    { id: 'tranexamic-acid',  label: 'Tranexamic acid' },
    { id: 'spf',              label: 'SPF' }
  ];

  /* =========================================================================
     QUIZ QUESTIONS
     type: 'single' | 'multi'. `max` limits multi selections.
     `showIf(answers)` (optional) controls conditional questions.
     ======================================================================= */
  var AMRB_QUESTIONS = [
    {
      id: 'skinType', type: 'single',
      title: 'How would you describe your skin?',
      sub: 'Choose the closest fit — this shapes texture and formula choices.',
      cols: true,
      options: [
        { value: 'dry', label: 'Dry' },
        { value: 'normal', label: 'Normal' },
        { value: 'oily', label: 'Oily' },
        { value: 'combination', label: 'Combination' },
        { value: 'sensitive', label: 'Sensitive' },
        { value: 'not-sure', label: 'Not sure' }
      ]
    },
    {
      id: 'goals', type: 'multi', max: 3,
      title: 'What are your primary skin goals?',
      sub: 'Choose up to three. Your routine is built around these.',
      cols: true,
      options: [
        { value: 'lines', label: 'Fine lines + wrinkles' },
        { value: 'pigment', label: 'Hyperpigmentation / uneven tone' },
        { value: 'texture', label: 'Texture' },
        { value: 'breakouts', label: 'Breakouts' },
        { value: 'pores', label: 'Visible pores' },
        { value: 'redness', label: 'Redness' },
        { value: 'dryness', label: 'Dryness / dehydration' },
        { value: 'firmness', label: 'Firmness' },
        { value: 'dullness', label: 'Dullness / radiance' },
        { value: 'prevention', label: 'Prevention / maintaining healthy skin' }
      ]
    },
    {
      id: 'sensitivity', type: 'single',
      title: 'How easily does your skin become irritated?',
      sub: 'This determines how actives are paced — not whether you can use them.',
      options: [
        { value: 'rarely', label: 'Rarely', desc: 'My skin tolerates most products well.' },
        { value: 'sometimes', label: 'Occasionally', desc: 'Certain strong products can cause redness or stinging.' },
        { value: 'easily', label: 'Easily', desc: 'New products often cause irritation.' },
        { value: 'very', label: 'Very reactive', desc: 'My skin reacts to many products, even gentle ones.' }
      ]
    },
    {
      id: 'actives', type: 'multi',
      title: 'Do you currently use products with any of these ingredients?',
      sub: 'Select all that apply. Skip any you’re unsure about.',
      cols: true,
      noneValue: 'none',
      options: [
        { value: 'retinol', label: 'Retinol / retinoids' },
        { value: 'vitamin-c', label: 'Vitamin C' },
        { value: 'exosomes', label: 'Exosomes' },
        { value: 'peptides', label: 'Peptides' },
        { value: 'aha', label: 'AHAs (glycolic, lactic…)' },
        { value: 'bha', label: 'BHAs (salicylic…)' },
        { value: 'benzoyl-peroxide', label: 'Benzoyl peroxide' },
        { value: 'hyaluronic-acid', label: 'Hyaluronic acid' },
        { value: 'other', label: 'Other treatment products' },
        { value: 'none', label: 'None of these' }
      ]
    },
    {
      id: 'treatments', type: 'single',
      title: 'Do professional treatments play a role in your skincare?',
      options: [
        { value: 'derm', label: 'I regularly see a dermatologist' },
        { value: 'aesthetic', label: 'I receive aesthetic treatments', desc: 'Lasers, peels, microneedling, injectables…' },
        { value: 'both', label: 'Both' },
        { value: 'neither', label: 'Neither' }
      ]
    },
    {
      id: 'treatmentTypes', type: 'multi',
      title: 'Which treatments do you receive?',
      sub: 'Optional — helps us think about recovery support. Always follow your provider’s post-procedure instructions.',
      cols: true,
      showIf: function (a) { return a.treatments === 'aesthetic' || a.treatments === 'both'; },
      optional: true,
      options: [
        { value: 'microneedling', label: 'Microneedling' },
        { value: 'laser', label: 'Laser treatments' },
        { value: 'peels', label: 'Chemical peels' },
        { value: 'injectables', label: 'Injectables' },
        { value: 'other', label: 'Other' }
      ]
    },
    {
      id: 'prescription', type: 'single',
      title: 'Do you use a prescription skincare product?',
      sub: 'For example tretinoin or another dermatologist-prescribed treatment.',
      options: [
        { value: 'retinoid', label: 'Yes — a prescription retinoid', desc: 'Tretinoin, adapalene, tazarotene…' },
        { value: 'other', label: 'Yes — another prescription product' },
        { value: 'none', label: 'No' }
      ]
    }
  ];

  /* =========================================================================
     PRODUCT DATABASE — THE A METHOD® CATALOG
     Source of truth for recommendations. Update as the catalog changes.
     All URLs point to live Shopify product pages; images are Shopify CDN.
     Fields:
       goals        — which quiz goals the product addresses
       skinTypes    — [] means all skin types
       time         — 'am' | 'pm' | 'both'
       slot         — layer key from AMRB_LAYERS
       actives      — ingredient tags (used by compatibility rules)
       caution      — tags used to filter by sensitivity, etc.
       priority     — tie-breaker when several products fit (higher wins)
     ======================================================================= */
  var AMRB_CATALOG = [
    {
      id: 'bubble-cleanser',
      name: 'Bubble Foaming Oxygenating Cleanser',
      url: 'https://theamethod.com/products/bubble-foaming-oxygenated-cleanser',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/bubble_oxygen_cleanser_68c2aa00-32b5-4a87-9da0-353ef3bc2464.webp?v=1780669296',
      category: 'Cleanser',
      keyIngredients: 'CO₂ foaming action, niacinamide, hyaluronic acid',
      goals: ['redness', 'breakouts', 'dryness', 'prevention'],
      skinTypes: [],
      time: 'both', slot: 'cleanse',
      actives: [], caution: [], priority: 2,
      desc: 'Softly cleanses while gently lifting debris and environmental pollutants — a gentle daily cleanser suited to every skin type, including sensitive skin.'
    },
    {
      id: 'cleanse-glycolic',
      name: 'Cleanse Glycolic Gel',
      url: 'https://theamethod.com/products/cleanse-glycolic-gel',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/cleasne_glycolic_gel.webp?v=1780672001',
      category: 'Cleanser',
      keyIngredients: 'Glycolic, lactic + salicylic acids',
      goals: ['texture', 'breakouts', 'dullness', 'pores', 'pigment'],
      skinTypes: ['oily', 'combination', 'normal'],
      time: 'both', slot: 'cleanse',
      actives: ['aha-bha-mild'], caution: ['exfoliating'], priority: 1,
      desc: 'A retexturizing, lightly foaming glycolic cleanser that tones while priming skin — a fit for oily, congestion-prone, or texture-focused routines.'
    },
    {
      id: 'pro-age-complex',
      name: 'Pro-Age Complex',
      url: 'https://theamethod.com/products/pro-age-complex',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/pro_age_complex_pads.webp?v=1780668780',
      category: 'Prep Pads',
      keyIngredients: '10% tranexamic acid + AHA/BHA blend',
      goals: ['pigment', 'texture', 'dullness'],
      skinTypes: ['normal', 'combination', 'oily', 'dry'],
      time: 'both', slot: 'prep',
      actives: ['aha-bha', 'tranexamic-acid'], caution: ['exfoliating'], priority: 2,
      desc: 'Treatment pads that balance tone and texture while helping follow-up products absorb — a one-swipe prep step.'
    },
    {
      id: 'c-brightening-pads',
      name: 'C Skin Brightening Pads',
      url: 'https://theamethod.com/products/c-skin-brightening-pads',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/c_skin_brightening_pads.webp?v=1780670524',
      category: 'Prep Pads',
      keyIngredients: 'Vitamin C, kojic acid + gentle exfoliating acids',
      goals: ['dullness', 'pigment'],
      skinTypes: ['normal', 'combination', 'oily'],
      time: 'both', slot: 'prep',
      actives: ['vitamin-c', 'aha-bha'], caution: ['exfoliating'], priority: 1,
      desc: 'Quick vitamin C application pads that target uneven tone and texture with a blend of brightening ingredients.'
    },
    {
      id: 'daily-blemish-pads',
      name: 'Daily Blemish Pads',
      url: 'https://theamethod.com/products/daily-blemish-pads',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/daily_blemish_pads_f47fb7ff-6dbf-42b9-b13d-ed6ef533cb99.webp?v=1780671979',
      category: 'Blemish Control',
      keyIngredients: 'Salicylic, glycolic + trichloroacetic acids',
      goals: ['breakouts', 'pores'],
      skinTypes: ['oily', 'combination', 'normal'],
      time: 'both', slot: 'prep',
      actives: ['aha-bha'], caution: ['exfoliating'], priority: 2,
      desc: 'A skin-purifying acid blend that provides deep exfoliation to keep blemish-prone skin looking clean, fresh, and clear.'
    },
    {
      id: 'c-antioxidant-gel',
      name: 'C Antioxidant Gel 20%',
      url: 'https://theamethod.com/products/c-antioxidant-gel-20',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/c_antioxidant_gel.webp?v=1780670568',
      category: 'Vitamin C Serum',
      keyIngredients: '20% THD ascorbate + vitamin E',
      goals: ['pigment', 'dullness', 'lines', 'prevention', 'firmness'],
      skinTypes: [],
      time: 'am', slot: 'treat',
      actives: ['vitamin-c'], caution: [], priority: 3,
      desc: 'A fast-absorbing vitamin C serum that helps protect from sun and pollution while supporting firmness and brightness — the antioxidant anchor of a morning routine.'
    },
    {
      id: 'advanced-tx',
      name: 'Advanced TX Lightening Gel Elixir',
      url: 'https://theamethod.com/products/advanced-tx-lightening-gel-elixir',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/advanced_tx.webp?v=1780670404',
      category: 'Treatment Serum',
      keyIngredients: 'Tranexamic acid, nicotinamide + arbutin',
      goals: ['pigment'],
      skinTypes: [],
      time: 'both', slot: 'treat',
      actives: ['tranexamic-acid'], caution: [], priority: 2,
      desc: 'A targeted serum for hyperpigmentation concerns that helps address discoloration at the source — gentle enough to pair with most routines.'
    },
    {
      id: 'skin-perfecting-serum',
      name: 'Skin Perfecting Serum',
      url: 'https://theamethod.com/products/skin-perfecting-serum',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/skin_perfecting_serum_2b541b3b-4959-4e12-988f-84864db4b823.webp?v=1780669866',
      category: 'Treatment Serum',
      keyIngredients: '10% tranexamic acid + exfoliating acid blend',
      goals: ['pigment', 'texture', 'pores', 'dullness'],
      skinTypes: ['normal', 'combination', 'oily'],
      time: 'both', slot: 'treat',
      actives: ['aha-bha', 'tranexamic-acid'], caution: ['exfoliating'], priority: 1,
      desc: 'A pigment-balancing, revitalizing serum addressing discoloration, texture, and pore concerns while improving the efficacy of the rest of your routine.'
    },
    {
      id: 'reti-xo',
      name: 'Reti-XO',
      url: 'https://theamethod.com/products/reti-xo',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/reti_xi_45ml.webp?v=1780669415',
      category: 'Retinol Serum',
      keyIngredients: '1% all-trans retinol, plant exosomes + copper tripeptides',
      goals: ['lines', 'firmness', 'texture', 'prevention'],
      skinTypes: [],
      time: 'pm', slot: 'treat',
      actives: ['retinol', 'exosomes', 'peptides'], caution: ['retinoid', 'pregnancy-flag'], priority: 3,
      desc: 'A serum pairing plant exosomes with gentle levels of 1% all-trans retinol to support strong collagen, a vibrant complexion, and improved elasticity. Optimized for nightly use.'
    },
    {
      id: 'pearls-of-retinol',
      name: 'Pearls of Retinol',
      url: 'https://theamethod.com/products/pearls-of-retinol',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/pearls_of_reitinol.webp?v=1780669331',
      category: 'Retinol Serum',
      keyIngredients: 'Micro-encapsulated all-trans retinol, hyaluronic acid + panthenol',
      goals: ['texture', 'pigment', 'pores', 'lines', 'breakouts'],
      skinTypes: ['sensitive', 'oily', 'combination'],
      time: 'pm', slot: 'treat',
      actives: ['retinol'], caution: ['retinoid', 'pregnancy-flag'], priority: 2,
      desc: 'Micro-encapsulated “pearls” of all-trans retinol in a non-irritating formula suitable for sensitive skin, with a powdery-dry finish that helps control shine.'
    },
    {
      id: 'zit-stopper',
      name: 'Zit Stopper',
      url: 'https://theamethod.com/products/zit-stopper',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/zit_stopper.webp?v=1780672022',
      category: 'Spot Treatment',
      keyIngredients: 'Salicylic acid + benzoyl peroxide',
      goals: ['breakouts'],
      skinTypes: ['oily', 'combination', 'normal'],
      time: 'both', slot: 'treat',
      actives: ['benzoyl-peroxide', 'aha-bha-mild'], caution: ['bpo'], priority: 1,
      desc: 'A convenient portable spot treatment for daily blemish control and prevention — applied only where needed.'
    },
    {
      id: 'hydrate-ha',
      name: 'Hydrate HA Elixir',
      url: 'https://theamethod.com/products/hydrate-ha-elixir',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/hydrate_ha_elixir.webp?v=1780671785',
      category: 'Hydrating Serum',
      keyIngredients: 'Two forms of hyaluronic acid + vitamin B5',
      goals: ['dryness', 'lines', 'redness', 'prevention'],
      skinTypes: [],
      time: 'both', slot: 'hydrate',
      actives: ['hyaluronic-acid'], caution: [], priority: 3,
      desc: 'A rehydrating serum with two forms of hyaluronic acid plus B5 to restore hydration and plump the appearance of fine lines.'
    },
    {
      id: 'ultra-hydration',
      name: 'Ultra-Hydration Serum',
      url: 'https://theamethod.com/products/ultra-hydration-serum',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/ultra_hydration_serum.webp?v=1780670214',
      category: 'Hydrating Serum',
      keyIngredients: '100% pure squalane, ceramide 3 + red ginseng',
      goals: ['dryness', 'redness', 'firmness'],
      skinTypes: ['dry', 'sensitive', 'normal'],
      time: 'both', slot: 'hydrate',
      actives: [], caution: [], priority: 2,
      desc: 'A supercharged antioxidant serum with squalane and ceramides to improve elasticity, comfort, and vibrance — well suited to drier or reactive skin.'
    },
    {
      id: 'orange-you-peppy',
      name: 'Orange You Peppy',
      url: 'https://theamethod.com/products/orange-you-peppy',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/orange_you_peppy.webp?v=1780672186',
      category: 'Peptide Moisturizer',
      keyIngredients: 'Triple peptide complex + 10% THD ascorbate (vitamin C)',
      goals: ['firmness', 'lines', 'dryness', 'dullness', 'prevention'],
      skinTypes: [],
      time: 'both', slot: 'moisturize',
      actives: ['peptides', 'vitamin-c-mild'], caution: [], priority: 3,
      desc: 'A facial moisturizer formulated with three peptides plus antioxidant vitamin C to nourish a healthy, hydrated complexion and support the skin barrier.'
    },
    {
      id: 'c-glow',
      name: 'C Glow Moisturizer',
      url: 'https://theamethod.com/products/c-glow-moisturizer',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/c_glow_moisturizer.webp?v=1780669740',
      category: 'Moisturizer',
      keyIngredients: '5% L-ascorbic acid + vitamin E',
      goals: ['dullness', 'pigment', 'dryness', 'prevention'],
      skinTypes: ['dry', 'normal', 'combination'],
      time: 'both', slot: 'moisturize',
      actives: ['vitamin-c-mild'], caution: [], priority: 2,
      desc: 'A preventative antioxidant moisturizer formulated with 5% L-ascorbic acid for a brighter-looking complexion and glow.'
    },
    {
      id: 'soothe-daily',
      name: 'Soothe Daily Arnica Balm',
      url: 'https://theamethod.com/products/soothe-daily-arnica-balm',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/soothe_25ml.webp?v=1780671938',
      category: 'Moisturizer',
      keyIngredients: 'Arnica montana, coconut milk + hyaluronic acid',
      goals: ['redness', 'dryness'],
      skinTypes: ['sensitive', 'dry'],
      time: 'both', slot: 'moisturize',
      actives: [], caution: [], priority: 2,
      desc: 'A calming daily moisturizer that delivers hydration and supports comfort — a strong barrier companion for routines built around actives, redness, or reactive skin.'
    },
    {
      id: 'collagen-eye',
      name: 'Collagen Boost Peptide Eye Cream',
      url: 'https://theamethod.com/products/collagen-boost-peptide-eye-cream',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/CollagenBoost.webp?v=1780671879',
      category: 'Eye Care',
      keyIngredients: 'Peptide complex + antioxidants',
      goals: ['lines', 'firmness', 'prevention'],
      skinTypes: [],
      time: 'both', slot: 'eye',
      actives: ['peptides'], caution: [], priority: 2,
      desc: 'An all-in-one daily peptide eye cream formulated with antioxidants to reduce the look of puffiness and revitalize tired eyes.'
    },
    {
      id: 'brighten-eyes',
      name: 'Brighten Eyes',
      url: 'https://theamethod.com/products/brighten-eyes',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/brighten_eyes.webp?v=1780670615',
      category: 'Eye Care',
      keyIngredients: 'All-trans retinol, vitamin K + rosemary',
      goals: ['lines', 'pigment', 'dullness'],
      skinTypes: [],
      time: 'pm', slot: 'eye',
      actives: ['retinol-eye'], caution: [], priority: 1,
      desc: 'An eye-brightening night cream using all-trans retinol, vitamin K, and rosemary to soften the look of lines with minimal irritation.'
    },
    {
      id: 'protection-powder',
      name: 'Protection Powder Sunscreen SPF 40',
      url: 'https://theamethod.com/products/protection-powder-sunscreen',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/clear_spf_brush_fe1d9761-49d2-4379-a31c-cf1cdee6e481.webp?v=1780670305',
      category: 'Sunscreen',
      keyIngredients: '100% mineral zinc oxide, SPF 40',
      goals: ['prevention', 'pigment', 'lines', 'redness', 'breakouts', 'texture', 'pores', 'dryness', 'firmness', 'dullness'],
      skinTypes: [],
      time: 'am', slot: 'protect',
      actives: ['spf'], caution: [], priority: 3,
      desc: 'A brush-on, 100% mineral broad-spectrum SPF 40 that layers over skincare or makeup with no white residue — the final step of every morning.'
    },
    {
      id: 'soothe-hc',
      name: 'Soothe HC Arnica Recovery Balm',
      url: 'https://theamethod.com/products/soothe-hc-arnica-recovery-balm',
      image: 'https://cdn.shopify.com/s/files/1/0701/5012/7830/files/soothe_hc_tube.webp?v=1780672293',
      category: 'Post-Procedure Care',
      keyIngredients: 'Arnica montana, low-dose hydrocortisone + hyaluronic acid',
      goals: ['redness'],
      skinTypes: [],
      time: 'both', slot: 'moisturize',
      actives: [], caution: ['post-procedure-only'], priority: 1,
      desc: 'A post-procedure recovery balm that hydrates compromised skin. Short-term use only, as directed by your treating provider — not an everyday moisturizer.'
    }
  ];

  /* =========================================================================
     COMPATIBILITY RULES
     How actives interact. The engine consults these when placing products
     and when generating insights. Edit messages freely.
     ======================================================================= */
  var AMRB_COMPAT = {
    /* Actives that count toward "active load" */
    loadActives: ['retinol', 'aha-bha', 'benzoyl-peroxide', 'vitamin-c', 'tranexamic-acid'],
    /* Pairs to separate (by tag). action: 'alternate' = alternate evenings,
       'split-ampm' = move one to AM */
    separations: [
      { a: 'retinol', b: 'aha-bha', action: 'alternate',
        note: 'Retinol and exfoliating acids are best used on different evenings. We’ve kept your exfoliating step on alternate nights.' },
      { a: 'retinol', b: 'benzoyl-peroxide', action: 'split-ampm',
        note: 'Benzoyl peroxide and retinol can work against each other when layered. We’ve placed benzoyl peroxide in the morning and retinol at night.' }
    ],
    /* Frequency guidance by sensitivity, for retinol + exfoliants */
    retinolFrequency: {
      rarely: 'Most evenings, as tolerated.',
      sometimes: 'Start with 3–4 evenings per week, building gradually.',
      easily: 'Start with 2–3 evenings per week, building gradually as tolerated.',
      very: 'Start with 1–2 evenings per week. Increase only if your skin stays comfortable.'
    },
    exfoliantFrequency: {
      rarely: '2–3 times per week.',
      sometimes: '2–3 times per week.',
      easily: '1–2 times per week.',
      very: 'Once per week, if tolerated.'
    }
  };

  /* =========================================================================
     RECOMMENDATION LOGIC — copy templates + step copy
     ======================================================================= */

  /* Copy shown inside expandable step cards, keyed by layer */
  var AMRB_STEP_WHY = {
    cleanse:    'Clean skin is the foundation. Anything applied over residue, oil, or sunscreen absorbs unevenly.',
    prep:       'The thinnest layer in your routine. Applied first after cleansing so it absorbs fully and preps skin for what follows.',
    treat:      'Concentrated actives work best on freshly cleansed skin, before heavier layers slow their absorption.',
    hydrate:    'Water-based hydration sits under moisturizer, drawing moisture in before it is sealed.',
    moisturize: 'Moisturizer seals in everything beneath it and supports the skin barrier — the last “skincare” layer before eye care and SPF.',
    eye:        'Applied near the end with light pressure, so treatments and moisturizer don’t migrate into the delicate eye area.',
    protect:    'SPF must sit on top of the routine to shield skin properly. It is always the final skincare step of the morning.',
    weekly:     'Used periodically rather than daily — best on evenings when your routine is otherwise gentle.'
  };

  var AMRB_STEP_HOW = {
    cleanse:    'Massage gently over damp skin, rinse with room-temperature water, and pat dry with a soft towel.',
    prep:       'Apply a thin layer (or swipe the pad) over face, neck, and décolleté. Let it absorb before the next step.',
    treat:      'Apply a thin, even layer to clean, dry skin. Allow it to absorb fully before layering the next product.',
    hydrate:    'Smooth a thin layer over the face and neck while skin is still slightly damp from the previous step.',
    moisturize: 'Apply evenly to face and neck after serums have absorbed, using gentle upward motions.',
    eye:        'Pat a small amount around the orbital bone with your ring finger, avoiding direct contact with the eyes.',
    protect:    'Apply generously as the final step, and reapply during extended sun exposure.',
    weekly:     'Use as directed on the packaging, on evenings without strong actives.'
  };

  /* =========================================================================
     ROUTINE ENGINE
     analyze(answers, shelf) -> result object consumed by the results view.
     ======================================================================= */

  function typeById(id) {
    for (var i = 0; i < AMRB_TYPES.length; i++) { if (AMRB_TYPES[i].id === id) return AMRB_TYPES[i]; }
    return AMRB_TYPES[AMRB_TYPES.length - 1];
  }

  /* Ingredient tags for a shelf item: user-selected tags + tags safely
     implied by the chosen category. Never inferred from the product name. */
  function itemActives(item) {
    var t = typeById(item.type);
    var set = {};
    (t.actives || []).forEach(function (a) { set[a] = true; });
    (item.actives || []).forEach(function (a) { set[a] = true; });
    if (set['aha'] || set['bha']) { set['aha-bha'] = true; }
    return set;
  }

  function goalLabel(v) {
    var q = null;
    for (var i = 0; i < AMRB_QUESTIONS.length; i++) { if (AMRB_QUESTIONS[i].id === 'goals') { q = AMRB_QUESTIONS[i]; break; } }
    if (q) { for (var j = 0; j < q.options.length; j++) { if (q.options[j].value === v) return q.options[j].label; } }
    return v;
  }

  function analyze(answers, shelf) {
    var sens = answers.sensitivity || 'sometimes';
    var goals = answers.goals || [];
    var hasRxRetinoid = answers.prescription === 'retinoid';
    var hasRxOther = answers.prescription === 'other';
    var proTx = answers.treatments === 'aesthetic' || answers.treatments === 'both';

    var am = [], pm = [], weekly = [], insights = [], gaps = [], recs = [];

    /* ---- classify shelf ---- */
    var items = shelf.map(function (raw) {
      var t = typeById(raw.type);
      return {
        raw: raw,
        name: raw.name,
        brand: raw.brand || '',
        type: t,
        actives: itemActives(raw),
        isRx: false
      };
    });

    var has = function (pred) { return items.some(pred); };
    var count = function (pred) { return items.filter(pred).length; };
    var hasActive = function (tag) { return has(function (it) { return it.actives[tag]; }); };

    /* Ingredients the user says they use (quiz), even if not added as products.
       Used for coverage + recommendation guards — never for step placement. */
    var declared = answers.actives || [];
    function declaredHas(tag) {
      if (tag === 'aha-bha') return declared.indexOf('aha') !== -1 || declared.indexOf('bha') !== -1;
      return declared.indexOf(tag) !== -1;
    }
    var signal = function (tag) { return hasActive(tag) || declaredHas(tag); };

    var retinolItems = items.filter(function (it) { return it.actives['retinol']; });
    var exfoliantItems = items.filter(function (it) { return it.actives['aha-bha']; });
    var bpoItems = items.filter(function (it) { return it.actives['benzoyl-peroxide']; });

    /* Prescription retinoid handling: flag an existing retinol item, or add a
       synthetic placeholder step. We never adjust how a prescription is used. */
    if (hasRxRetinoid) {
      if (retinolItems.length) {
        retinolItems[0].isRx = true;
      } else {
        var rxItem = {
          raw: { name: 'Your prescription retinoid', brand: '', type: 'retinol' },
          name: 'Your prescription retinoid', brand: '',
          type: typeById('retinol'),
          actives: { retinol: true }, isRx: true
        };
        items.push(rxItem);
        retinolItems = [rxItem];
      }
    }

    var hasRetinol = retinolItems.length > 0;
    var altExfoliant = hasRetinol && exfoliantItems.length > 0;
    var splitBpo = hasRetinol && bpoItems.length > 0;

    /* ---- build steps ---- */
    function makeStep(it, time) {
      var slot = it.type.slot;
      var freq = '', flag = '', extra = '';
      var catLabel = it.type.label;

      if (it.isRx) {
        flag = 'Prescription — follow your prescriber’s directions';
        freq = 'As prescribed by your clinician.';
        extra = 'We haven’t changed how this product is used. Apply it exactly as your prescribing clinician directed.';
      } else if (it.actives['retinol'] && time === 'pm') {
        freq = AMRB_COMPAT.retinolFrequency[sens] || AMRB_COMPAT.retinolFrequency.sometimes;
      } else if (it.actives['aha-bha'] && slot !== 'cleanse') {
        if (altExfoliant && time === 'pm') {
          freq = 'Alternate evenings — on nights you skip ' + (hasRxRetinoid ? 'your prescription retinoid' : 'retinol') + '.';
        } else {
          freq = AMRB_COMPAT.exfoliantFrequency[sens] || AMRB_COMPAT.exfoliantFrequency.sometimes;
        }
      } else if (it.actives['benzoyl-peroxide'] && splitBpo && time === 'am') {
        freq = 'Mornings, to keep it separate from evening retinol.';
      } else if (it.type.id === 'acne' || it.type.id === 'zit' ) {
        freq = 'As needed on areas of concern.';
      } else if (slot === 'protect') {
        freq = 'Every morning. Reapply during extended sun exposure.';
      }

      var why = AMRB_STEP_WHY[slot] || AMRB_STEP_WHY.treat;
      if (it.type.id === 'vitamin-c' && time === 'am') {
        why = 'Vitamin C supports the skin against environmental stress, so it earns its place in the morning — under moisturizer and SPF.';
      }
      if (it.actives['retinol'] && time === 'pm' && !it.isRx) {
        why = 'Retinol supports overnight renewal and can make skin more sun-aware, so it belongs in the evening routine.';
      }
      if (it.type.id === 'face-oil') {
        why = 'Oils are among the thickest layers in a routine, so they go near the end — after or in place of moisturizer.';
      }
      if (it.type.id === 'other') {
        extra = (extra ? extra + ' ' : '') + 'Positioned based on the product category you selected. If its packaging says otherwise, follow the label.';
        flag = flag || 'Positioned by category';
      }

      return {
        name: it.name,
        brand: it.brand,
        cat: catLabel,
        slot: slot,
        why: why,
        how: AMRB_STEP_HOW[slot] || AMRB_STEP_HOW.treat,
        freq: freq,
        flag: flag,
        extra: extra,
        isRec: false
      };
    }

    items.forEach(function (it) {
      var t = it.type;
      var slot = t.slot;
      if (slot === 'weekly') {
        weekly.push({ name: it.name, note: '1–2 times per week, on evenings without strong actives.' });
        return;
      }
      var goesAm = t.am, goesPm = t.pm;

      /* COMPATIBILITY RULES applied to placement */
      if (it.actives['retinol'] || it.actives['exosomes']) { goesAm = false; goesPm = true; }
      if (it.actives['aha-bha'] && slot !== 'cleanse') { goesAm = false; goesPm = true; }
      if (it.type.id === 'vitamin-c' || (it.actives['vitamin-c'] && slot === 'treat')) { goesAm = true; goesPm = false; }
      if (it.actives['benzoyl-peroxide'] && splitBpo) { goesAm = true; goesPm = false; }
      if (it.actives['spf']) { goesAm = true; goesPm = false; }
      if (it.isRx) { goesAm = false; goesPm = true; }

      if (goesAm) am.push(makeStep(it, 'am'));
      if (goesPm) pm.push(makeStep(it, 'pm'));
    });

    /* Sort by layering order; face oils after moisturizers within the slot */
    function sortRoutine(list, order) {
      list.sort(function (a, b) {
        var d = order.indexOf(a.slot) - order.indexOf(b.slot);
        if (d !== 0) return d;
        var ao = a.cat === 'Face oil' ? 1 : 0, bo = b.cat === 'Face oil' ? 1 : 0;
        return ao - bo;
      });
    }
    sortRoutine(am, AMRB_AM_ORDER);
    sortRoutine(pm, AMRB_PM_ORDER);

    /* ---- goal coverage (based on the user's own products) ---- */
    var coverage = {
      lines: signal('retinol') || signal('peptides') || signal('vitamin-c'),
      pigment: signal('vitamin-c') || signal('tranexamic-acid') || signal('aha-bha') || signal('retinol'),
      texture: signal('aha-bha') || signal('retinol'),
      breakouts: signal('benzoyl-peroxide') || has(function (it) { return it.type.id === 'acne'; }) || signal('aha-bha'),
      pores: signal('aha-bha') || signal('retinol') || signal('niacinamide'),
      redness: signal('niacinamide') || has(function (it) { return it.type.slot === 'moisturize'; }),
      dryness: has(function (it) { return it.type.slot === 'hydrate' || it.type.slot === 'moisturize'; }),
      firmness: signal('retinol') || signal('peptides'),
      dullness: signal('vitamin-c') || signal('aha-bha'),
      prevention: hasActive('spf')
    };
    var goalsCovered = goals.filter(function (g) { return coverage[g]; });

    /* ---- foundational structure ---- */
    var slotsOccupied = {};
    am.concat(pm).forEach(function (s) { slotsOccupied[s.slot] = true; });
    var foundational = ['cleanse', 'treat', 'hydrate', 'moisturize', 'eye', 'protect'];
    var foundCount = foundational.filter(function (k) { return slotsOccupied[k]; }).length;

    /* ---- active load ---- */
    var loadCount = count(function (it) {
      return AMRB_COMPAT.loadActives.some(function (tag) { return it.actives[tag]; });
    });
    var activeLoad = loadCount <= 1 ? 'Low' : (loadCount <= 3 ? 'Moderate' : 'High');

    var hasMoisturizer = has(function (it) { return it.type.slot === 'moisturize'; });
    var barrier = hasMoisturizer ? (activeLoad === 'High' ? 'Moderate' : 'Strong') : 'Needs support';

    /* =====================================================================
       SMART INSIGHTS — short, practical observations
       ===================================================================== */
    var exfoliatingCount = exfoliantItems.length + count(function (it) { return it.actives['aha-bha-mild'] && !it.actives['aha-bha']; });
    if (items.length === 0) {
      insights.push('You’re starting fresh — the recommendations below outline the smallest effective routine for your goals. You can return anytime to add what you own.');
    }
    if (altExfoliant) {
      insights.push('You’re using ' + (hasRxRetinoid ? 'a prescription retinoid' : 'retinol') + ' at night. We’ve kept your exfoliating treatment on alternate evenings so the two don’t compete.');
    } else if (exfoliantItems.length >= 2) {
      insights.push('You’re using two exfoliating products. Consider alternating them rather than layering both in the same routine.');
    }
    if (splitBpo) {
      insights.push('Benzoyl peroxide and retinol can destabilize each other when layered, so we’ve separated them — benzoyl peroxide in the morning, retinol at night.');
    }
    var hydrationCount = count(function (it) { return it.type.slot === 'hydrate' || it.type.slot === 'moisturize'; });
    if (hydrationCount >= 2 && !hasActive('spf')) {
      insights.push('You have multiple products targeting hydration, but no daily SPF — protection is the step your routine will benefit from most.');
    }
    if (activeLoad === 'High') {
      insights.push('Your routine contains several active products. More isn’t always better — we’ve paced frequencies so your skin barrier can keep up.');
    }
    if ((sens === 'easily' || sens === 'very') && loadCount >= 2) {
      insights.push('Because your skin irritates easily, we’ve set conservative frequencies for your actives. Increase slowly, one product at a time.');
    }
    if (has(function (it) { return it.type.id === 'vitamin-c'; })) {
      insights.push('Vitamin C sits in your morning routine, where its antioxidant support pairs naturally with SPF.');
    }
    if (hasRxOther) {
      insights.push('You mentioned a prescription product. We haven’t repositioned it — apply it exactly as your prescribing clinician directed.');
    }
    if (proTx) {
      insights.push('Around in-office treatments, your provider’s post-procedure instructions always take priority over this routine — including pausing actives when directed.');
    }
    if (goals.indexOf('pigment') !== -1 && coverage.pigment && !hasActive('spf')) {
      insights.push('Your routine targets pigmentation, but without daily SPF those gains are easily undone. Sun protection is the most important pigment step.');
    }
    /* Declared ingredients that never made it onto the shelf */
    if (items.length) {
      var missingDeclared = [];
      if (declaredHas('retinol') && !hasActive('retinol') && !hasRxRetinoid) missingDeclared.push('retinol');
      if (declaredHas('vitamin-c') && !hasActive('vitamin-c')) missingDeclared.push('vitamin C');
      if (declaredHas('aha-bha') && !hasActive('aha-bha')) missingDeclared.push('your exfoliating acid');
      if (missingDeclared.length) {
        insights.push('You mentioned using ' + missingDeclared.join(' and ') + ', but it isn’t on your shelf yet. Add it under “Edit products” and we’ll position it correctly.');
      }
    }
    insights = insights.slice(0, 5);

    /* =====================================================================
       GAP ANALYSIS — essential vs optional
       ===================================================================== */
    var hasCleanser = !!slotsOccupied['cleanse'];
    var hasSpf = hasActive('spf');
    var hasHydrator = has(function (it) { return it.type.slot === 'hydrate'; });
    var hasEye = !!slotsOccupied['eye'];
    var hasAmAntiox = signal('vitamin-c');
    var pmHasTreatment = pm.some(function (s) { return s.slot === 'treat' || s.slot === 'prep'; });

    if (!hasCleanser) {
      gaps.push({ level: 'essential', key: 'cleanse', title: 'Cleansing',
        body: 'Your routine doesn’t currently include a cleanser. Every routine — morning and evening — starts on clean skin.' });
    }
    if (!hasSpf) {
      gaps.push({ level: 'essential', key: 'protect', title: 'Daily Protection',
        body: 'You don’t currently have an SPF in your morning routine. Daily sun protection is the single most effective step for nearly every skin goal.' });
    }
    if (!hasMoisturizer) {
      gaps.push({ level: 'essential', key: 'moisturize', title: 'Barrier Support',
        body: 'There’s no moisturizer sealing your routine. Without it, hydration escapes and actives are harder to tolerate.' });
    }
    /* Uncovered goals → treatment gaps */
    var uncovered = goals.filter(function (g) { return !coverage[g]; });
    uncovered.forEach(function (g) {
      if (g === 'prevention' && !hasSpf) return;   /* already captured by SPF gap */
      if (g === 'dryness' && !hasMoisturizer) return; /* captured by moisturizer gap */
      gaps.push({
        level: pmHasTreatment ? 'optional' : 'essential',
        key: 'goal:' + g,
        title: 'Targeted Treatment — ' + goalLabel(g),
        body: 'You selected ' + goalLabel(g).toLowerCase() + ' as a goal, but nothing in your routine currently targets it.'
      });
    });
    if (!hasHydrator && (goals.indexOf('dryness') !== -1 || goals.indexOf('lines') !== -1) && hasMoisturizer) {
      gaps.push({ level: 'optional', key: 'hydrate', title: 'A Dedicated Hydration Layer',
        body: 'A water-based hydrating serum under your moisturizer would deepen hydration and plump the look of fine lines.' });
    }
    if (!hasEye && (goals.indexOf('lines') !== -1 || goals.indexOf('firmness') !== -1)) {
      gaps.push({ level: 'optional', key: 'eye', title: 'Targeted Eye Care',
        body: 'Your goals include ' + (goals.indexOf('lines') !== -1 ? 'fine lines' : 'firmness') + ', but your routine doesn’t currently include a targeted eye product.' });
    }
    if (!hasAmAntiox && (goals.indexOf('prevention') !== -1 || goals.indexOf('dullness') !== -1 || goals.indexOf('pigment') !== -1)) {
      gaps.push({ level: 'optional', key: 'antioxidant', title: 'Morning Antioxidant Support',
        body: 'An antioxidant serum in the morning helps defend against the environmental stress that drives dullness and uneven tone.' });
    }
    if (proTx && barrier !== 'Strong') {
      gaps.push({ level: 'optional', key: 'recovery', title: 'Recovery Support',
        body: 'Since professional treatments are part of your skincare, a calming, barrier-supportive product helps between visits. Always follow your provider’s post-procedure instructions first.' });
    }
    gaps.sort(function (a, b) { return (a.level === 'essential' ? 0 : 1) - (b.level === 'essential' ? 0 : 1); });
    gaps = gaps.slice(0, 6);

    /* =====================================================================
       RECOMMENDATION LOGIC — one product per gap, max 4, never invented
       ===================================================================== */
    function ownsLike(product) {
      var pn = product.name.toLowerCase();
      return shelf.some(function (s) {
        var n = (s.name || '').toLowerCase();
        return n && (pn.indexOf(n) !== -1 || n.indexOf(pn) !== -1);
      });
    }
    function allowed(p) {
      if (ownsLike(p)) return false;
      if (p.caution.indexOf('post-procedure-only') !== -1 && !proTx) return false;
      /* Never add another retinoid on top of an existing / declared /
         prescription one */
      if (p.caution.indexOf('retinoid') !== -1 && (hasRetinol || hasRxRetinoid || declaredHas('retinol'))) return false;
      /* Skip additional exfoliating products for very reactive skin or
         routines already carrying exfoliants or a heavy active load */
      if (p.caution.indexOf('exfoliating') !== -1 && (sens === 'very' || activeLoad === 'High' || exfoliantItems.length > 0 || declaredHas('aha-bha'))) return false;
      if (p.caution.indexOf('bpo') !== -1 && (hasRetinol || declaredHas('retinol'))) return false;
      if (p.skinTypes.length && answers.skinType && answers.skinType !== 'not-sure' && p.skinTypes.indexOf(answers.skinType) === -1) return false;
      if ((sens === 'easily' || sens === 'very') && p.id === 'reti-xo') return false; /* prefer the gentler retinol */
      return true;
    }
    function score(p, gapKey) {
      var s = p.priority || 0;
      goals.forEach(function (g) { if (p.goals.indexOf(g) !== -1) s += 2; });
      if (p.skinTypes.length && p.skinTypes.indexOf(answers.skinType) !== -1) s += 1;
      if (gapKey.indexOf('goal:') === 0 && p.goals.indexOf(gapKey.slice(5)) !== -1) s += 3;
      return s;
    }
    function pickFor(gap) {
      var pool = AMRB_CATALOG.filter(function (p) {
        if (!allowed(p)) return false;
        if (gap.key === 'cleanse') return p.slot === 'cleanse';
        if (gap.key === 'protect') return p.slot === 'protect';
        if (gap.key === 'moisturize') return p.slot === 'moisturize' && p.caution.indexOf('post-procedure-only') === -1;
        if (gap.key === 'hydrate') return p.slot === 'hydrate';
        if (gap.key === 'eye') return p.slot === 'eye';
        if (gap.key === 'antioxidant') return p.actives.indexOf('vitamin-c') !== -1 && p.slot === 'treat';
        if (gap.key === 'recovery') return p.id === 'soothe-hc' || p.id === 'soothe-daily';
        if (gap.key.indexOf('goal:') === 0) { return p.goals.indexOf(gap.key.slice(5)) !== -1 && p.slot !== 'protect'; }
        return false;
      });
      pool.sort(function (a, b) { return score(b, gap.key) - score(a, gap.key); });
      return pool[0] || null;
    }

    var usedIds = {};
    gaps.forEach(function (gap) {
      if (recs.length >= 4) return;
      var p = pickFor(gap);
      if (!p || usedIds[p.id]) return;
      usedIds[p.id] = true;

      var whyBits = [];
      var matched = goals.filter(function (g) { return p.goals.indexOf(g) !== -1; }).map(goalLabel);
      if (gap.key.indexOf('goal:') === 0 || gap.key === 'antioxidant') {
        whyBits.push('Recommended because your goals include ' + (matched.slice(0, 2).join(' and ').toLowerCase() || 'this concern') + '.');
      } else {
        whyBits.push('Recommended to fill your “' + gap.title.toLowerCase() + '” gap.');
      }
      var timeLabel = p.time === 'am' ? 'AM' : (p.time === 'pm' ? 'PM' : 'AM · PM');
      var slotLabel = '';
      for (var li = 0; li < AMRB_LAYERS.length; li++) { if (AMRB_LAYERS[li].key === p.slot) slotLabel = AMRB_LAYERS[li].label; }
      var caution = '';
      if (p.caution.indexOf('pregnancy-flag') !== -1) {
        caution = 'Retinol is generally not recommended during pregnancy or nursing — check with your physician.';
      }
      if (p.id === 'soothe-hc') {
        caution = 'Short-term, post-procedure use only — follow your treating provider’s directions.';
      }
      recs.push({
        product: p,
        gapTitle: gap.title,
        gapLevel: gap.level,
        why: whyBits.join(' ') + ' ' + p.desc,
        placement: timeLabel + ' · ' + slotLabel,
        caution: caution
      });
    });

    /* ---- AM / PM themes for the "MY METHOD" header ---- */
    function theme(list, isAm) {
      if (isAm) {
        if (hasActive('vitamin-c') && hasSpf) return 'Protect + Brighten';
        if (hasSpf) return 'Protect + Prepare';
        if (hasActive('vitamin-c')) return 'Brighten + Defend';
        return 'Cleanse + Prepare';
      }
      if (hasRetinol) return 'Renew + Recover';
      if (exfoliantItems.length) return 'Refine + Restore';
      return 'Replenish + Rest';
    }

    return {
      am: am, pm: pm, weekly: weekly,
      insights: insights, gaps: gaps, recs: recs,
      glance: {
        goalsCovered: goalsCovered.length,
        goalsTotal: goals.length,
        foundational: foundCount,
        foundationalTotal: 6,
        activeLoad: activeLoad,
        barrier: barrier
      },
      amTheme: theme(am, true),
      pmTheme: theme(pm, false),
      generated: new Date().toISOString()
    };
  }

  /* =========================================================================
     UTILITIES
     ======================================================================= */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* LocalStorage with graceful failure (private mode, blocked storage…) */
  var store = {
    get: function () {
      try { var raw = window.localStorage.getItem(AMRB_BRAND.storageKey); return raw ? JSON.parse(raw) : null; }
      catch (e) { return null; }
    },
    set: function (data) {
      try { window.localStorage.setItem(AMRB_BRAND.storageKey, JSON.stringify(data)); } catch (e) { /* no-op */ }
    },
    clear: function () {
      try { window.localStorage.removeItem(AMRB_BRAND.storageKey); } catch (e) { /* no-op */ }
    }
  };

  /* =========================================================================
     STATE
     ======================================================================= */
  var state = {
    view: 'idle',            /* idle | quiz | shelf | analyzing | results */
    qIndex: 0,
    answers: {},
    shelf: [],
    editingId: null,
    formOpen: false,
    result: null
  };
  var uidSeed = 1;

  var mount = ROOT.querySelector('[data-amrb-app]');
  var live = document.createElement('div');
  live.setAttribute('aria-live', 'polite');
  live.className = 'amrb-sr';
  ROOT.appendChild(live);
  function announce(msg) { live.textContent = msg; }

  function visibleQuestions() {
    return AMRB_QUESTIONS.filter(function (q) { return !q.showIf || q.showIf(state.answers); });
  }
  function totalSteps() { return visibleQuestions().length + 1; } /* +1 = shelf */

  function scrollToApp() {
    var top = ROOT.querySelector('.amrb-app');
    if (top && top.getBoundingClientRect().top < -10) {
      top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* =========================================================================
     RENDER DISPATCH
     ======================================================================= */
  function render() {
    if (state.view === 'idle') { mount.innerHTML = ''; return; }
    if (state.view === 'quiz') renderQuiz();
    else if (state.view === 'shelf') renderShelf();
    else if (state.view === 'analyzing') renderAnalyzing();
    else if (state.view === 'results') renderResults();
    scrollToApp();
    var h = mount.querySelector('[data-amrb-focus]');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }

  function topbar(stepNum, backHandlerName) {
    var pct = Math.round((stepNum - 1) / totalSteps() * 100);
    return '' +
      '<div class="amrb-topbar">' +
        '<button type="button" class="amrb-btn--quiet amrb-btn" data-amrb-back' + (stepNum <= 1 ? ' disabled' : '') + '>&larr; Back</button>' +
        '<span class="amrb-stepcount">Step ' + stepNum + ' of ' + totalSteps() + '</span>' +
        '<button type="button" class="amrb-btn--quiet amrb-btn" data-amrb-restart>Restart</button>' +
      '</div>' +
      '<div class="amrb-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Routine builder progress">' +
        '<div class="amrb-progress-fill" style="width:' + pct + '%"></div>' +
      '</div>';
  }

  /* =========================================================================
     QUIZ VIEW
     ======================================================================= */
  function renderQuiz() {
    var qs = visibleQuestions();
    if (state.qIndex >= qs.length) { state.view = 'shelf'; renderShelf(); return; }
    var q = qs[state.qIndex];
    var current = state.answers[q.id];
    var selected = q.type === 'multi' ? (current || []) : current;

    var opts = q.options.map(function (o) {
      var isSel = q.type === 'multi' ? selected.indexOf(o.value) !== -1 : selected === o.value;
      var aria = q.type === 'multi' ? 'aria-pressed' : 'aria-checked';
      var role = q.type === 'multi' ? '' : ' role="radio"';
      return '<button type="button" class="amrb-opt"' + role + ' ' + aria + '="' + (isSel ? 'true' : 'false') + '" data-amrb-opt="' + esc(o.value) + '">' +
        '<span><span class="amrb-opt-label">' + esc(o.label) + '</span>' +
        (o.desc ? '<span class="amrb-opt-desc">' + esc(o.desc) + '</span>' : '') + '</span>' +
        '<span class="amrb-opt-tick" aria-hidden="true"></span>' +
      '</button>';
    }).join('');

    mount.innerHTML =
      '<div class="amrb-view">' + topbar(state.qIndex + 1) +
      '<div class="amrb-q">' +
        '<span class="amrb-eyebrow amrb-eyebrow--accent">Personalization</span>' +
        '<h3 class="amrb-h2" data-amrb-focus>' + esc(q.title) + '</h3>' +
        (q.sub ? '<p class="amrb-q-sub">' + esc(q.sub) + '</p>' : '') +
        '<div class="amrb-opts' + (q.cols ? ' amrb-opts--cols' : '') + '"' + (q.type === 'single' ? ' role="radiogroup" aria-label="' + esc(q.title) + '"' : '') + '>' + opts + '</div>' +
        '<div class="amrb-q-actions">' +
          (q.type === 'multi'
            ? '<button type="button" class="amrb-btn" data-amrb-next' + (!q.optional && !selected.length ? ' disabled' : '') + '>' + (q.optional && !selected.length ? 'Skip' : 'Continue') + '</button>'
            : '') +
          (q.max ? '<span class="amrb-maxnote">' + selected.length + ' of ' + q.max + ' selected</span>' : '') +
        '</div>' +
      '</div></div>';

    announce('Question ' + (state.qIndex + 1) + ' of ' + qs.length + ': ' + q.title);

    mount.querySelectorAll('[data-amrb-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-amrb-opt');
        if (q.type === 'single') {
          if (state._advancing) return; /* prevent double-tap skipping a question */
          state._advancing = true;
          state.answers[q.id] = v;
          /* If a change makes later conditional answers stale, prune them */
          AMRB_QUESTIONS.forEach(function (qq) {
            if (qq.showIf && !qq.showIf(state.answers)) delete state.answers[qq.id];
          });
          renderQuiz(); /* show selection state */
          window.setTimeout(function () { state._advancing = false; state.qIndex += 1; render(); }, 220);
        } else {
          var arr = (state.answers[q.id] || []).slice();
          var i = arr.indexOf(v);
          if (i !== -1) { arr.splice(i, 1); }
          else {
            if (q.noneValue && v === q.noneValue) { arr = [v]; }
            else {
              if (q.noneValue) { var ni = arr.indexOf(q.noneValue); if (ni !== -1) arr.splice(ni, 1); }
              if (q.max && arr.length >= q.max) { return; }
              arr.push(v);
            }
          }
          state.answers[q.id] = arr;
          renderQuiz();
        }
      });
    });
    var next = mount.querySelector('[data-amrb-next]');
    if (next) next.addEventListener('click', function () { state.qIndex += 1; render(); });
    wireCommon();
  }

  /* =========================================================================
     SHELF VIEW — "What's already on your shelf?"
     ======================================================================= */
  function renderShelf() {
    state.view = 'shelf';
    var listHtml;
    if (!state.shelf.length) {
      listHtml = '<div class="amrb-empty">Nothing here yet. Add the products you already use &mdash; any brand &mdash; and we&rsquo;ll organize them. You can also continue without adding anything.</div>';
    } else {
      listHtml = '<ul class="amrb-shelf-list" style="list-style:none">' + state.shelf.map(function (p) {
        var t = typeById(p.type);
        return '<li class="amrb-shelf-item">' +
          '<div class="amrb-shelf-item-main">' +
            '<div class="amrb-shelf-item-name">' + esc(p.name) + (p.brand ? ' <span class="amrb-small">&mdash; ' + esc(p.brand) + '</span>' : '') + '</div>' +
            '<div class="amrb-shelf-item-meta">' + esc(t.label) + (p.actives && p.actives.length ? ' &middot; ' + p.actives.map(function (a) {
              for (var i = 0; i < AMRB_ACTIVE_TAGS.length; i++) { if (AMRB_ACTIVE_TAGS[i].id === a) return AMRB_ACTIVE_TAGS[i].label; }
              return a;
            }).join(', ') : '') + '</div>' +
          '</div>' +
          '<div class="amrb-shelf-item-actions">' +
            '<button type="button" class="amrb-iconbtn" data-amrb-edit="' + esc(p.id) + '" aria-label="Edit ' + esc(p.name) + '">Edit</button>' +
            '<button type="button" class="amrb-iconbtn" data-amrb-remove="' + esc(p.id) + '" aria-label="Remove ' + esc(p.name) + '">&times;</button>' +
          '</div>' +
        '</li>';
      }).join('') + '</ul>';
    }

    var editing = state.editingId ? state.shelf.filter(function (p) { return p.id === state.editingId; })[0] : null;
    var formHtml = '';
    if (state.formOpen) {
      var typeOpts = AMRB_TYPES.map(function (t) {
        return '<option value="' + t.id + '"' + (editing && editing.type === t.id ? ' selected' : '') + '>' + esc(t.label) + '</option>';
      }).join('');
      var chipHtml = AMRB_ACTIVE_TAGS.map(function (a) {
        var on = editing && editing.actives && editing.actives.indexOf(a.id) !== -1;
        return '<button type="button" class="amrb-chip" aria-pressed="' + (on ? 'true' : 'false') + '" data-amrb-chip="' + a.id + '">' + esc(a.label) + '</button>';
      }).join('');
      formHtml =
        '<div class="amrb-form" role="group" aria-label="' + (editing ? 'Edit product' : 'Add a product') + '">' +
          '<div class="amrb-field"><label for="amrb-f-name">Product name</label>' +
            '<input type="text" id="amrb-f-name" autocomplete="off" placeholder="e.g. CeraVe Hydrating Cleanser" value="' + esc(editing ? editing.name : '') + '"></div>' +
          '<div class="amrb-field"><label for="amrb-f-brand">Brand <span style="text-transform:none;letter-spacing:0">(optional)</span></label>' +
            '<input type="text" id="amrb-f-brand" autocomplete="off" value="' + esc(editing ? editing.brand || '' : '') + '"></div>' +
          '<div class="amrb-field"><label for="amrb-f-type">Product type</label>' +
            '<select id="amrb-f-type"><option value="">Select a type&hellip;</option>' + typeOpts + '</select></div>' +
          '<div class="amrb-field"><label id="amrb-f-actives-label">Key ingredients <span style="text-transform:none;letter-spacing:0">(optional &mdash; if you know them)</span></label>' +
            '<div class="amrb-chiprow" role="group" aria-labelledby="amrb-f-actives-label">' + chipHtml + '</div></div>' +
          '<div class="amrb-error" data-amrb-form-error hidden></div>' +
          '<div class="amrb-form-actions">' +
            '<button type="button" class="amrb-btn" data-amrb-save-product>' + (editing ? 'Save changes' : 'Add product') + '</button>' +
            '<button type="button" class="amrb-btn amrb-btn--ghost" data-amrb-cancel-product>Cancel</button>' +
          '</div>' +
        '</div>';
    }

    mount.innerHTML =
      '<div class="amrb-view">' + topbar(totalSteps()) +
      '<div class="amrb-shelf">' +
        '<span class="amrb-eyebrow amrb-eyebrow--accent">Your current products</span>' +
        '<h3 class="amrb-h2" data-amrb-focus style="text-transform:none;letter-spacing:0">What&rsquo;s already on your shelf?</h3>' +
        '<p class="amrb-q-sub">Add anything you use today &mdash; from any brand. A simple entry like &ldquo;CeraVe cleanser&rdquo; is enough; the ingredient details are optional.</p>' +
        listHtml + formHtml +
        (!state.formOpen ? '<button type="button" class="amrb-btn amrb-btn--ghost" data-amrb-add>+ Add a product</button>' : '') +
        '<div class="amrb-q-actions" style="margin-top:34px">' +
          '<button type="button" class="amrb-btn" data-amrb-analyze>' + (state.shelf.length ? 'Build my routine' : 'Continue without products') + '</button>' +
        '</div>' +
      '</div></div>';

    var addBtn = mount.querySelector('[data-amrb-add]');
    if (addBtn) addBtn.addEventListener('click', function () { state.editingId = null; state.formOpen = true; renderShelf(); var f = mount.querySelector('#amrb-f-name'); if (f) f.focus(); });

    mount.querySelectorAll('[data-amrb-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-amrb-remove');
        state.shelf = state.shelf.filter(function (p) { return p.id !== id; });
        if (state.editingId === id) { state.editingId = null; state.formOpen = false; }
        announce('Product removed.');
        renderShelf();
      });
    });
    mount.querySelectorAll('[data-amrb-edit]').forEach(function (b) {
      b.addEventListener('click', function () { state.editingId = b.getAttribute('data-amrb-edit'); state.formOpen = true; renderShelf(); });
    });

    if (state.formOpen) {
      mount.querySelectorAll('[data-amrb-chip]').forEach(function (c) {
        c.addEventListener('click', function () {
          c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        });
      });
      mount.querySelector('[data-amrb-cancel-product]').addEventListener('click', function () {
        state.formOpen = false; state.editingId = null; renderShelf();
      });
      mount.querySelector('[data-amrb-save-product]').addEventListener('click', function () {
        var name = mount.querySelector('#amrb-f-name').value.trim();
        var brand = mount.querySelector('#amrb-f-brand').value.trim();
        var type = mount.querySelector('#amrb-f-type').value;
        var err = mount.querySelector('[data-amrb-form-error]');
        if (!name || !type) {
          err.textContent = !name ? 'Please give the product a name.' : 'Please choose the closest product type — it tells us where the product belongs.';
          err.hidden = false;
          return;
        }
        var actives = [];
        mount.querySelectorAll('[data-amrb-chip][aria-pressed="true"]').forEach(function (c) { actives.push(c.getAttribute('data-amrb-chip')); });
        if (state.editingId) {
          state.shelf = state.shelf.map(function (p) {
            return p.id === state.editingId ? { id: p.id, name: name, brand: brand, type: type, actives: actives } : p;
          });
          announce(name + ' updated.');
        } else {
          state.shelf.push({ id: 'p' + (uidSeed++) + Date.now(), name: name, brand: brand, type: type, actives: actives });
          announce(name + ' added to your shelf.');
        }
        state.formOpen = false; state.editingId = null;
        renderShelf();
      });
    }

    mount.querySelector('[data-amrb-analyze]').addEventListener('click', function () {
      state.view = 'analyzing'; render();
    });
    wireCommon();
  }

  /* =========================================================================
     ANALYZING VIEW — brief, honest pause while the engine runs
     ======================================================================= */
  function renderAnalyzing() {
    var lines = ['Reading your goals…', 'Checking ingredient compatibility…', 'Sequencing your layers…'];
    mount.innerHTML =
      '<div class="amrb-view"><div class="amrb-analyzing">' +
        '<div class="amrb-pulse" aria-hidden="true"></div>' +
        '<h3 class="amrb-h2" data-amrb-focus style="text-transform:none;letter-spacing:0">Building your method</h3>' +
        '<p class="amrb-analyzing-line" data-amrb-line>' + lines[0] + '</p>' +
      '</div></div>';
    announce('Building your routine.');
    var el = mount.querySelector('[data-amrb-line]');
    var i = 0;
    var iv = window.setInterval(function () {
      i += 1;
      if (el && lines[i]) el.textContent = lines[i];
    }, 550);
    window.setTimeout(function () {
      window.clearInterval(iv);
      try {
        state.result = analyze(state.answers, state.shelf);
      } catch (e) {
        state.result = null;
      }
      if (!state.result) {
        mount.innerHTML = '<div class="amrb-view"><div class="amrb-analyzing"><p>Something went wrong while building your routine. <button type="button" class="amrb-btn amrb-btn--ghost" data-amrb-retry style="margin-top:16px">Try again</button></p></div></div>';
        var r = mount.querySelector('[data-amrb-retry]');
        if (r) r.addEventListener('click', function () { state.view = 'shelf'; render(); });
        return;
      }
      store.set({ answers: state.answers, shelf: state.shelf, savedAt: Date.now() });
      state.view = 'results';
      render();
    }, 1800);
  }

  /* =========================================================================
     RESULTS VIEW — MY METHOD
     ======================================================================= */
  function stepCard(step, idx, routineKey) {
    var num = (idx + 1 < 10 ? '0' : '') + (idx + 1);
    var slotLabel = '';
    for (var i = 0; i < AMRB_LAYERS.length; i++) { if (AMRB_LAYERS[i].key === step.slot) slotLabel = AMRB_LAYERS[i].label; }
    var bodyId = 'amrb-step-' + routineKey + '-' + idx;
    return '' +
      '<div class="amrb-step">' +
        '<button type="button" class="amrb-step-btn" aria-expanded="false" aria-controls="' + bodyId + '">' +
          '<span class="amrb-step-num" aria-hidden="true">' + num + '</span>' +
          '<span class="amrb-step-main">' +
            '<span class="amrb-step-cat">' + esc(slotLabel) + ' &middot; ' + esc(step.cat) + '</span>' +
            '<span class="amrb-step-name">' + esc(step.name) + (step.brand ? ' <span class="amrb-small">&mdash; ' + esc(step.brand) + '</span>' : '') + '</span>' +
            (step.freq ? '<span class="amrb-step-freq">' + esc(step.freq) + '</span>' : '') +
            (step.flag ? '<span class="amrb-step-flag">' + esc(step.flag) + '</span>' : '') +
          '</span>' +
          '<span class="amrb-step-caret" aria-hidden="true">+</span>' +
        '</button>' +
        '<div class="amrb-step-body" id="' + bodyId + '" hidden>' +
          '<div><strong>Why this step?</strong>' + esc(step.why) + '</div>' +
          '<div><strong>How to apply</strong>' + esc(step.how) + '</div>' +
          (step.extra ? '<div><strong>Note</strong>' + esc(step.extra) + '</div>' : '') +
        '</div>' +
      '</div>';
  }

  function renderResults() {
    var r = state.result;
    var goals = (state.answers.goals || []).map(goalLabel);
    var dateStr = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });

    var amHtml = r.am.length
      ? r.am.map(function (s, i) { return stepCard(s, i, 'am'); }).join('')
      : '<div class="amrb-routine-empty">No morning products yet &mdash; see the recommendations below for where to begin.</div>';
    var pmHtml = r.pm.length
      ? r.pm.map(function (s, i) { return stepCard(s, i, 'pm'); }).join('')
      : '<div class="amrb-routine-empty">No evening products yet &mdash; see the recommendations below for where to begin.</div>';

    var weeklyHtml = r.weekly.length
      ? '<div class="amrb-weekly"><b>Weekly:</b> ' + r.weekly.map(function (w) { return esc(w.name) + ' &mdash; ' + esc(w.note); }).join(' &nbsp;&middot;&nbsp; ') + '</div>'
      : '';

    var insightsHtml = r.insights.length
      ? '<section class="amrb-section" aria-labelledby="amrb-insights-t"><div class="amrb-section-head">' +
          '<span class="amrb-eyebrow">Smart Routine Insights</span><h3 class="amrb-h2" id="amrb-insights-t">What we noticed</h3></div>' +
          '<div class="amrb-insights">' + r.insights.map(function (t) { return '<div class="amrb-insight">' + esc(t) + '</div>'; }).join('') + '</div></section>'
      : '';

    var gapsHtml = r.gaps.length
      ? '<section class="amrb-section" aria-labelledby="amrb-gaps-t"><div class="amrb-section-head">' +
          '<span class="amrb-eyebrow">Routine Analysis</span><h3 class="amrb-h2" id="amrb-gaps-t">Where your routine has room</h3>' +
          '<p class="amrb-lede">Not every category is essential for every person. These are the gaps that matter for your goals, in order of priority.</p></div>' +
          '<div class="amrb-gaps">' + r.gaps.map(function (g) {
            return '<div class="amrb-gap amrb-gap--' + g.level + '">' +
              '<span class="amrb-gap-tag">' + (g.level === 'essential' ? 'Essential gap' : 'Optional upgrade') + '</span>' +
              '<div class="amrb-gap-title">' + esc(g.title) + '</div>' +
              '<div class="amrb-gap-body">' + esc(g.body) + '</div></div>';
          }).join('') + '</div></section>'
      : '';

    var recsHtml = r.recs.length
      ? '<section class="amrb-section" aria-labelledby="amrb-recs-t"><div class="amrb-section-head">' +
          '<span class="amrb-eyebrow amrb-eyebrow--accent">From The A Method&reg;</span><h3 class="amrb-h2" id="amrb-recs-t">A better fit for your routine</h3>' +
          '<p class="amrb-lede">Selected only where they address your goals or a gap above &mdash; nothing more.</p></div>' +
          '<div class="amrb-recs">' + r.recs.map(function (rec) {
            var p = rec.product;
            return '<article class="amrb-rec">' +
              '<div class="amrb-rec-imgwrap"><img src="' + esc(p.image) + '" alt="' + esc(p.name) + '" loading="lazy" width="240" height="180" onerror="this.parentNode.style.display=\'none\'"></div>' +
              '<div class="amrb-rec-body">' +
                '<span class="amrb-rec-cat">' + esc(p.category) + '</span>' +
                '<h4 class="amrb-rec-name">' + esc(p.name) + '</h4>' +
                '<span class="amrb-rec-slot">' + esc(rec.placement) + '</span>' +
                '<p class="amrb-rec-why">' + esc(rec.why) + '</p>' +
                '<p class="amrb-rec-why"><em>Key ingredients:</em> ' + esc(p.keyIngredients) + '</p>' +
                (rec.caution ? '<p class="amrb-rec-caution">' + esc(rec.caution) + '</p>' : '') +
                '<a class="amrb-btn" href="' + esc(p.url) + '" target="_blank" rel="noopener">View Product</a>' +
              '</div></article>';
          }).join('') + '</div></section>'
      : '';

    var whyOrderHtml =
      '<section class="amrb-section" aria-labelledby="amrb-why-t"><div class="amrb-section-head">' +
        '<span class="amrb-eyebrow">The Methodology</span><h3 class="amrb-h2" id="amrb-why-t">Why this order?</h3>' +
        '<p class="amrb-lede">Learn the logic once and you can place any product you ever buy. Tap each layer.</p></div>' +
        '<div class="amrb-stack" data-amrb-stack2></div></section>';

    var glance = r.glance;
    var glanceHtml =
      '<section class="amrb-section" aria-labelledby="amrb-glance-t"><div class="amrb-section-head">' +
        '<span class="amrb-eyebrow">Summary</span><h3 class="amrb-h2" id="amrb-glance-t">Your routine at a glance</h3></div>' +
        '<div class="amrb-glance">' +
          '<div class="amrb-glance-cell"><div class="amrb-glance-label">Goals covered</div><div class="amrb-glance-value">' + glance.goalsCovered + ' / ' + glance.goalsTotal + '</div><div class="amrb-glance-note">by your current products</div></div>' +
          '<div class="amrb-glance-cell"><div class="amrb-glance-label">Foundational steps</div><div class="amrb-glance-value">' + glance.foundational + ' / ' + glance.foundationalTotal + '</div><div class="amrb-glance-note">cleanse to protect</div></div>' +
          '<div class="amrb-glance-cell"><div class="amrb-glance-label">Active load</div><div class="amrb-glance-value">' + esc(glance.activeLoad) + '</div><div class="amrb-glance-note">paced to your sensitivity</div></div>' +
          '<div class="amrb-glance-cell"><div class="amrb-glance-label">Barrier support</div><div class="amrb-glance-value">' + esc(glance.barrier) + '</div><div class="amrb-glance-note">hydration + moisture seal</div></div>' +
        '</div></section>';

    mount.innerHTML =
      '<div class="amrb-view">' +
      '<div class="amrb-results-head">' +
        '<span class="amrb-eyebrow amrb-eyebrow--accent">' + esc(AMRB_BRAND.name) + '</span>' +
        '<h3 class="amrb-h1" data-amrb-focus>' + esc(AMRB_BRAND.resultTitle) + '</h3>' +
        '<p class="amrb-hero-sub">' + esc(AMRB_BRAND.resultTagline) + '</p>' +
        (goals.length ? '<div class="amrb-results-goals">' + goals.map(function (g) { return '<span class="amrb-goalpill">' + esc(g) + '</span>'; }).join('') + '</div>' : '') +
        '<p class="amrb-results-summary-line">Morning &mdash; ' + esc(r.amTheme) + ' &nbsp;&middot;&nbsp; Evening &mdash; ' + esc(r.pmTheme) + '</p>' +
        '<div class="amrb-footer-actions">' +
          '<button type="button" class="amrb-btn amrb-btn--quiet" data-amrb-edit-answers>Edit answers</button>' +
          '<button type="button" class="amrb-btn amrb-btn--quiet" data-amrb-edit-shelf>Edit products</button>' +
          '<button type="button" class="amrb-btn amrb-btn--quiet" data-amrb-restart>Start over</button>' +
        '</div>' +
      '</div>' +

      '<div class="amrb-routines">' +
        '<div><div class="amrb-routine-head"><span class="amrb-eyebrow">Good morning</span>' +
          '<div class="amrb-routine-title">AM Routine</div><div class="amrb-routine-theme">' + esc(r.amTheme) + '</div></div>' + amHtml + '</div>' +
        '<div><div class="amrb-routine-head"><span class="amrb-eyebrow">Good night</span>' +
          '<div class="amrb-routine-title">PM Routine</div><div class="amrb-routine-theme">' + esc(r.pmTheme) + '</div></div>' + pmHtml + '</div>' +
      '</div>' +
      weeklyHtml +
      insightsHtml + gapsHtml + recsHtml + glanceHtml + whyOrderHtml +

      '<div class="amrb-save">' +
        '<span class="amrb-eyebrow amrb-eyebrow--accent">Keep it with you</span>' +
        '<h3 class="amrb-h2">Save my routine</h3>' +
        '<p class="amrb-lede" style="margin:12px auto 0">Download a routine card for your phone, or print a copy for the bathroom mirror. Your card includes code <strong>' + esc(AMRB_BRAND.promoCode) + '</strong> for 30% off your next product purchase. Your routine is also saved here for your next visit.</p>' +
        '<div class="amrb-save-actions">' +
          '<button type="button" class="amrb-btn" data-amrb-download>Download routine card</button>' +
          '<button type="button" class="amrb-btn amrb-btn--ghost" data-amrb-print>Print / save as PDF</button>' +
        '</div>' +
        '<p class="amrb-small" data-amrb-save-msg style="margin-top:14px" hidden></p>' +
      '</div>' +

      '<p class="amrb-disclaimer">' + esc(AMRB_BRAND.disclaimer) + '</p>' +
      '</div>';

    announce('Your personalized routine is ready.');

    /* expandable steps */
    mount.querySelectorAll('.amrb-step-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        if (body) body.hidden = open;
      });
    });

    buildStack(mount.querySelector('[data-amrb-stack2]'), 'r');

    mount.querySelector('[data-amrb-edit-answers]').addEventListener('click', function () {
      state.view = 'quiz'; state.qIndex = 0; render();
    });
    mount.querySelector('[data-amrb-edit-shelf]').addEventListener('click', function () {
      state.view = 'shelf'; state.formOpen = false; state.editingId = null; render();
    });
    mount.querySelector('[data-amrb-download]').addEventListener('click', downloadCard);
    mount.querySelector('[data-amrb-print]').addEventListener('click', printCard);
    wireCommon();
  }

  /* =========================================================================
     EDUCATION STACK (shared by intro section + results)
     ======================================================================= */
  function buildStack(container, keyPrefix) {
    if (!container) return;
    container.innerHTML = AMRB_LAYERS.map(function (l, i) {
      var id = 'amrb-layer-' + keyPrefix + '-' + i;
      return '<div class="amrb-layer">' +
        '<button type="button" class="amrb-layer-btn" aria-expanded="false" aria-controls="' + id + '">' +
          '<span class="amrb-layer-num" aria-hidden="true">' + (i + 1) + '</span>' +
          '<span class="amrb-layer-name">' + esc(l.label) + (l.pm === false ? ' <span style="color:var(--amrb-muted);font-weight:400;letter-spacing:.06em;text-transform:none">(AM only)</span>' : '') + '</span>' +
          '<span class="amrb-layer-caret" aria-hidden="true">+</span>' +
        '</button>' +
        '<div class="amrb-layer-body" id="' + id + '" hidden>' + esc(l.why) + '</div>' +
      '</div>';
    }).join('');
    container.querySelectorAll('.amrb-layer-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        if (body) body.hidden = open;
      });
    });
  }

  /* =========================================================================
     COMMON WIRING — back / restart on every view
     ======================================================================= */
  function wireCommon() {
    var back = mount.querySelector('[data-amrb-back]');
    if (back) back.addEventListener('click', function () {
      if (state.view === 'shelf') {
        state.view = 'quiz'; state.qIndex = visibleQuestions().length - 1;
      } else if (state.view === 'quiz' && state.qIndex > 0) {
        state.qIndex -= 1;
      }
      render();
    });
    mount.querySelectorAll('[data-amrb-restart]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!window.confirm('Start over? Your answers and products will be cleared.')) return;
        store.clear();
        state.answers = {}; state.shelf = []; state.qIndex = 0; state.result = null;
        state.formOpen = false; state.editingId = null;
        state.view = 'quiz';
        render();
      });
    });
  }

  /* =========================================================================
     QR CODE LIBRARY (embedded)
     "QR Code Generator" by Kazuhiko Arase — MIT licensed (minified, verbatim).
     Scoped inside this IIFE: the `qrcode` function below is NOT global.
     ======================================================================= */
  var qrcode=function(){var t=function(t,r){var e=t,n=g[r],o=null,i=0,a=null,u=[],f={},c=function(t,r){o=function(t){for(var r=new Array(t),e=0;e<t;e+=1){r[e]=new Array(t);for(var n=0;n<t;n+=1)r[e][n]=null}return r}(i=4*e+17),l(0,0),l(i-7,0),l(0,i-7),s(),h(),d(t,r),e>=7&&v(t),null==a&&(a=p(e,n,u)),w(a,r)},l=function(t,r){for(var e=-1;e<=7;e+=1)if(!(t+e<=-1||i<=t+e))for(var n=-1;n<=7;n+=1)r+n<=-1||i<=r+n||(o[t+e][r+n]=0<=e&&e<=6&&(0==n||6==n)||0<=n&&n<=6&&(0==e||6==e)||2<=e&&e<=4&&2<=n&&n<=4)},h=function(){for(var t=8;t<i-8;t+=1)null==o[t][6]&&(o[t][6]=t%2==0);for(var r=8;r<i-8;r+=1)null==o[6][r]&&(o[6][r]=r%2==0)},s=function(){for(var t=B.getPatternPosition(e),r=0;r<t.length;r+=1)for(var n=0;n<t.length;n+=1){var i=t[r],a=t[n];if(null==o[i][a])for(var u=-2;u<=2;u+=1)for(var f=-2;f<=2;f+=1)o[i+u][a+f]=-2==u||2==u||-2==f||2==f||0==u&&0==f}},v=function(t){for(var r=B.getBCHTypeNumber(e),n=0;n<18;n+=1){var a=!t&&1==(r>>n&1);o[Math.floor(n/3)][n%3+i-8-3]=a}for(n=0;n<18;n+=1){a=!t&&1==(r>>n&1);o[n%3+i-8-3][Math.floor(n/3)]=a}},d=function(t,r){for(var e=n<<3|r,a=B.getBCHTypeInfo(e),u=0;u<15;u+=1){var f=!t&&1==(a>>u&1);u<6?o[u][8]=f:u<8?o[u+1][8]=f:o[i-15+u][8]=f}for(u=0;u<15;u+=1){f=!t&&1==(a>>u&1);u<8?o[8][i-u-1]=f:u<9?o[8][15-u-1+1]=f:o[8][15-u-1]=f}o[i-8][8]=!t},w=function(t,r){for(var e=-1,n=i-1,a=7,u=0,f=B.getMaskFunction(r),c=i-1;c>0;c-=2)for(6==c&&(c-=1);;){for(var g=0;g<2;g+=1)if(null==o[n][c-g]){var l=!1;u<t.length&&(l=1==(t[u]>>>a&1)),f(n,c-g)&&(l=!l),o[n][c-g]=l,-1==(a-=1)&&(u+=1,a=7)}if((n+=e)<0||i<=n){n-=e,e=-e;break}}},p=function(t,r,e){for(var n=A.getRSBlocks(t,r),o=b(),i=0;i<e.length;i+=1){var a=e[i];o.put(a.getMode(),4),o.put(a.getLength(),B.getLengthInBits(a.getMode(),t)),a.write(o)}var u=0;for(i=0;i<n.length;i+=1)u+=n[i].dataCount;if(o.getLengthInBits()>8*u)throw"code length overflow. ("+o.getLengthInBits()+">"+8*u+")";for(o.getLengthInBits()+4<=8*u&&o.put(0,4);o.getLengthInBits()%8!=0;)o.putBit(!1);for(;!(o.getLengthInBits()>=8*u||(o.put(236,8),o.getLengthInBits()>=8*u));)o.put(17,8);return function(t,r){for(var e=0,n=0,o=0,i=new Array(r.length),a=new Array(r.length),u=0;u<r.length;u+=1){var f=r[u].dataCount,c=r[u].totalCount-f;n=Math.max(n,f),o=Math.max(o,c),i[u]=new Array(f);for(var g=0;g<i[u].length;g+=1)i[u][g]=255&t.getBuffer()[g+e];e+=f;var l=B.getErrorCorrectPolynomial(c),h=k(i[u],l.getLength()-1).mod(l);for(a[u]=new Array(l.getLength()-1),g=0;g<a[u].length;g+=1){var s=g+h.getLength()-a[u].length;a[u][g]=s>=0?h.getAt(s):0}}var v=0;for(g=0;g<r.length;g+=1)v+=r[g].totalCount;var d=new Array(v),w=0;for(g=0;g<n;g+=1)for(u=0;u<r.length;u+=1)g<i[u].length&&(d[w]=i[u][g],w+=1);for(g=0;g<o;g+=1)for(u=0;u<r.length;u+=1)g<a[u].length&&(d[w]=a[u][g],w+=1);return d}(o,n)};f.addData=function(t,r){var e=null;switch(r=r||"Byte"){case"Numeric":e=M(t);break;case"Alphanumeric":e=x(t);break;case"Byte":e=m(t);break;case"Kanji":e=L(t);break;default:throw"mode:"+r}u.push(e),a=null},f.isDark=function(t,r){if(t<0||i<=t||r<0||i<=r)throw t+","+r;return o[t][r]},f.getModuleCount=function(){return i},f.make=function(){if(e<1){for(var t=1;t<40;t++){for(var r=A.getRSBlocks(t,n),o=b(),i=0;i<u.length;i++){var a=u[i];o.put(a.getMode(),4),o.put(a.getLength(),B.getLengthInBits(a.getMode(),t)),a.write(o)}var g=0;for(i=0;i<r.length;i++)g+=r[i].dataCount;if(o.getLengthInBits()<=8*g)break}e=t}c(!1,function(){for(var t=0,r=0,e=0;e<8;e+=1){c(!0,e);var n=B.getLostPoint(f);(0==e||t>n)&&(t=n,r=e)}return r}())},f.createTableTag=function(t,r){t=t||2;var e="";e+='<table style="',e+=" border-width: 0px; border-style: none;",e+=" border-collapse: collapse;",e+=" padding: 0px; margin: "+(r=void 0===r?4*t:r)+"px;",e+='">',e+="<tbody>";for(var n=0;n<f.getModuleCount();n+=1){e+="<tr>";for(var o=0;o<f.getModuleCount();o+=1)e+='<td style="',e+=" border-width: 0px; border-style: none;",e+=" border-collapse: collapse;",e+=" padding: 0px; margin: 0px;",e+=" width: "+t+"px;",e+=" height: "+t+"px;",e+=" background-color: ",e+=f.isDark(n,o)?"#000000":"#ffffff",e+=";",e+='"/>';e+="</tr>"}return e+="</tbody>",e+="</table>"},f.createSvgTag=function(t,r,e,n){var o={};"object"==typeof arguments[0]&&(t=(o=arguments[0]).cellSize,r=o.margin,e=o.alt,n=o.title),t=t||2,r=void 0===r?4*t:r,(e="string"==typeof e?{text:e}:e||{}).text=e.text||null,e.id=e.text?e.id||"qrcode-description":null,(n="string"==typeof n?{text:n}:n||{}).text=n.text||null,n.id=n.text?n.id||"qrcode-title":null;var i,a,u,c,g=f.getModuleCount()*t+2*r,l="";for(c="l"+t+",0 0,"+t+" -"+t+",0 0,-"+t+"z ",l+='<svg version="1.1" xmlns="http://www.w3.org/2000/svg"',l+=o.scalable?"":' width="'+g+'px" height="'+g+'px"',l+=' viewBox="0 0 '+g+" "+g+'" ',l+=' preserveAspectRatio="xMinYMin meet"',l+=n.text||e.text?' role="img" aria-labelledby="'+y([n.id,e.id].join(" ").trim())+'"':"",l+=">",l+=n.text?'<title id="'+y(n.id)+'">'+y(n.text)+"</title>":"",l+=e.text?'<description id="'+y(e.id)+'">'+y(e.text)+"</description>":"",l+='<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>',l+='<path d="',a=0;a<f.getModuleCount();a+=1)for(u=a*t+r,i=0;i<f.getModuleCount();i+=1)f.isDark(a,i)&&(l+="M"+(i*t+r)+","+u+c);return l+='" stroke="transparent" fill="black"/>',l+="</svg>"},f.createDataURL=function(t,r){t=t||2,r=void 0===r?4*t:r;var e=f.getModuleCount()*t+2*r,n=r,o=e-r;return I(e,e,function(r,e){if(n<=r&&r<o&&n<=e&&e<o){var i=Math.floor((r-n)/t),a=Math.floor((e-n)/t);return f.isDark(a,i)?0:1}return 1})},f.createImgTag=function(t,r,e){t=t||2,r=void 0===r?4*t:r;var n=f.getModuleCount()*t+2*r,o="";return o+="<img",o+=' src="',o+=f.createDataURL(t,r),o+='"',o+=' width="',o+=n,o+='"',o+=' height="',o+=n,o+='"',e&&(o+=' alt="',o+=y(e),o+='"'),o+="/>"};var y=function(t){for(var r="",e=0;e<t.length;e+=1){var n=t.charAt(e);switch(n){case"<":r+="&lt;";break;case">":r+="&gt;";break;case"&":r+="&amp;";break;case'"':r+="&quot;";break;default:r+=n}}return r};return f.createASCII=function(t,r){if((t=t||1)<2)return function(t){t=void 0===t?2:t;var r,e,n,o,i,a=1*f.getModuleCount()+2*t,u=t,c=a-t,g={"██":"█","█ ":"▀"," █":"▄","  ":" "},l={"██":"▀","█ ":"▀"," █":" ","  ":" "},h="";for(r=0;r<a;r+=2){for(n=Math.floor((r-u)/1),o=Math.floor((r+1-u)/1),e=0;e<a;e+=1)i="█",u<=e&&e<c&&u<=r&&r<c&&f.isDark(n,Math.floor((e-u)/1))&&(i=" "),u<=e&&e<c&&u<=r+1&&r+1<c&&f.isDark(o,Math.floor((e-u)/1))?i+=" ":i+="█",h+=t<1&&r+1>=c?l[i]:g[i];h+="\n"}return a%2&&t>0?h.substring(0,h.length-a-1)+Array(a+1).join("▀"):h.substring(0,h.length-1)}(r);t-=1,r=void 0===r?2*t:r;var e,n,o,i,a=f.getModuleCount()*t+2*r,u=r,c=a-r,g=Array(t+1).join("██"),l=Array(t+1).join("  "),h="",s="";for(e=0;e<a;e+=1){for(o=Math.floor((e-u)/t),s="",n=0;n<a;n+=1)i=1,u<=n&&n<c&&u<=e&&e<c&&f.isDark(o,Math.floor((n-u)/t))&&(i=0),s+=i?g:l;for(o=0;o<t;o+=1)h+=s+"\n"}return h.substring(0,h.length-1)},f.renderTo2dContext=function(t,r){r=r||2;for(var e=f.getModuleCount(),n=0;n<e;n++)for(var o=0;o<e;o++)t.fillStyle=f.isDark(n,o)?"black":"white",t.fillRect(o*r,n*r,r,r)},f};t.stringToBytes=(t.stringToBytesFuncs={default:function(t){for(var r=[],e=0;e<t.length;e+=1){var n=t.charCodeAt(e);r.push(255&n)}return r}}).default,t.createStringToBytes=function(t,r){var e=function(){for(var e=S(t),n=function(){var t=e.read();if(-1==t)throw"eof";return t},o=0,i={};;){var a=e.read();if(-1==a)break;var u=n(),f=n()<<8|n();i[String.fromCharCode(a<<8|u)]=f,o+=1}if(o!=r)throw o+" != "+r;return i}(),n="?".charCodeAt(0);return function(t){for(var r=[],o=0;o<t.length;o+=1){var i=t.charCodeAt(o);if(i<128)r.push(i);else{var a=e[t.charAt(o)];"number"==typeof a?(255&a)==a?r.push(a):(r.push(a>>>8),r.push(255&a)):r.push(n)}}return r}};var r,e,n,o,i,a=1,u=2,f=4,c=8,g={L:1,M:0,Q:3,H:2},l=0,h=1,s=2,v=3,d=4,w=5,p=6,y=7,B=(r=[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],e=1335,n=7973,i=function(t){for(var r=0;0!=t;)r+=1,t>>>=1;return r},(o={}).getBCHTypeInfo=function(t){for(var r=t<<10;i(r)-i(e)>=0;)r^=e<<i(r)-i(e);return 21522^(t<<10|r)},o.getBCHTypeNumber=function(t){for(var r=t<<12;i(r)-i(n)>=0;)r^=n<<i(r)-i(n);return t<<12|r},o.getPatternPosition=function(t){return r[t-1]},o.getMaskFunction=function(t){switch(t){case l:return function(t,r){return(t+r)%2==0};case h:return function(t,r){return t%2==0};case s:return function(t,r){return r%3==0};case v:return function(t,r){return(t+r)%3==0};case d:return function(t,r){return(Math.floor(t/2)+Math.floor(r/3))%2==0};case w:return function(t,r){return t*r%2+t*r%3==0};case p:return function(t,r){return(t*r%2+t*r%3)%2==0};case y:return function(t,r){return(t*r%3+(t+r)%2)%2==0};default:throw"bad maskPattern:"+t}},o.getErrorCorrectPolynomial=function(t){for(var r=k([1],0),e=0;e<t;e+=1)r=r.multiply(k([1,C.gexp(e)],0));return r},o.getLengthInBits=function(t,r){if(1<=r&&r<10)switch(t){case a:return 10;case u:return 9;case f:case c:return 8;default:throw"mode:"+t}else if(r<27)switch(t){case a:return 12;case u:return 11;case f:return 16;case c:return 10;default:throw"mode:"+t}else{if(!(r<41))throw"type:"+r;switch(t){case a:return 14;case u:return 13;case f:return 16;case c:return 12;default:throw"mode:"+t}}},o.getLostPoint=function(t){for(var r=t.getModuleCount(),e=0,n=0;n<r;n+=1)for(var o=0;o<r;o+=1){for(var i=0,a=t.isDark(n,o),u=-1;u<=1;u+=1)if(!(n+u<0||r<=n+u))for(var f=-1;f<=1;f+=1)o+f<0||r<=o+f||0==u&&0==f||a==t.isDark(n+u,o+f)&&(i+=1);i>5&&(e+=3+i-5)}for(n=0;n<r-1;n+=1)for(o=0;o<r-1;o+=1){var c=0;t.isDark(n,o)&&(c+=1),t.isDark(n+1,o)&&(c+=1),t.isDark(n,o+1)&&(c+=1),t.isDark(n+1,o+1)&&(c+=1),0!=c&&4!=c||(e+=3)}for(n=0;n<r;n+=1)for(o=0;o<r-6;o+=1)t.isDark(n,o)&&!t.isDark(n,o+1)&&t.isDark(n,o+2)&&t.isDark(n,o+3)&&t.isDark(n,o+4)&&!t.isDark(n,o+5)&&t.isDark(n,o+6)&&(e+=40);for(o=0;o<r;o+=1)for(n=0;n<r-6;n+=1)t.isDark(n,o)&&!t.isDark(n+1,o)&&t.isDark(n+2,o)&&t.isDark(n+3,o)&&t.isDark(n+4,o)&&!t.isDark(n+5,o)&&t.isDark(n+6,o)&&(e+=40);var g=0;for(o=0;o<r;o+=1)for(n=0;n<r;n+=1)t.isDark(n,o)&&(g+=1);return e+=Math.abs(100*g/r/r-50)/5*10},o),C=function(){for(var t=new Array(256),r=new Array(256),e=0;e<8;e+=1)t[e]=1<<e;for(e=8;e<256;e+=1)t[e]=t[e-4]^t[e-5]^t[e-6]^t[e-8];for(e=0;e<255;e+=1)r[t[e]]=e;var n={glog:function(t){if(t<1)throw"glog("+t+")";return r[t]},gexp:function(r){for(;r<0;)r+=255;for(;r>=256;)r-=255;return t[r]}};return n}();function k(t,r){if(void 0===t.length)throw t.length+"/"+r;var e=function(){for(var e=0;e<t.length&&0==t[e];)e+=1;for(var n=new Array(t.length-e+r),o=0;o<t.length-e;o+=1)n[o]=t[o+e];return n}(),n={getAt:function(t){return e[t]},getLength:function(){return e.length},multiply:function(t){for(var r=new Array(n.getLength()+t.getLength()-1),e=0;e<n.getLength();e+=1)for(var o=0;o<t.getLength();o+=1)r[e+o]^=C.gexp(C.glog(n.getAt(e))+C.glog(t.getAt(o)));return k(r,0)},mod:function(t){if(n.getLength()-t.getLength()<0)return n;for(var r=C.glog(n.getAt(0))-C.glog(t.getAt(0)),e=new Array(n.getLength()),o=0;o<n.getLength();o+=1)e[o]=n.getAt(o);for(o=0;o<t.getLength();o+=1)e[o]^=C.gexp(C.glog(t.getAt(o))+r);return k(e,0).mod(t)}};return n}var A=function(){var t=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12,7,37,13],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]],r=function(t,r){var e={};return e.totalCount=t,e.dataCount=r,e},e={};return e.getRSBlocks=function(e,n){var o=function(r,e){switch(e){case g.L:return t[4*(r-1)+0];case g.M:return t[4*(r-1)+1];case g.Q:return t[4*(r-1)+2];case g.H:return t[4*(r-1)+3];default:return}}(e,n);if(void 0===o)throw"bad rs block @ typeNumber:"+e+"/errorCorrectionLevel:"+n;for(var i=o.length/3,a=[],u=0;u<i;u+=1)for(var f=o[3*u+0],c=o[3*u+1],l=o[3*u+2],h=0;h<f;h+=1)a.push(r(c,l));return a},e}(),b=function(){var t=[],r=0,e={getBuffer:function(){return t},getAt:function(r){var e=Math.floor(r/8);return 1==(t[e]>>>7-r%8&1)},put:function(t,r){for(var n=0;n<r;n+=1)e.putBit(1==(t>>>r-n-1&1))},getLengthInBits:function(){return r},putBit:function(e){var n=Math.floor(r/8);t.length<=n&&t.push(0),e&&(t[n]|=128>>>r%8),r+=1}};return e},M=function(t){var r=a,e=t,n={getMode:function(){return r},getLength:function(t){return e.length},write:function(t){for(var r=e,n=0;n+2<r.length;)t.put(o(r.substring(n,n+3)),10),n+=3;n<r.length&&(r.length-n==1?t.put(o(r.substring(n,n+1)),4):r.length-n==2&&t.put(o(r.substring(n,n+2)),7))}},o=function(t){for(var r=0,e=0;e<t.length;e+=1)r=10*r+i(t.charAt(e));return r},i=function(t){if("0"<=t&&t<="9")return t.charCodeAt(0)-"0".charCodeAt(0);throw"illegal char :"+t};return n},x=function(t){var r=u,e=t,n={getMode:function(){return r},getLength:function(t){return e.length},write:function(t){for(var r=e,n=0;n+1<r.length;)t.put(45*o(r.charAt(n))+o(r.charAt(n+1)),11),n+=2;n<r.length&&t.put(o(r.charAt(n)),6)}},o=function(t){if("0"<=t&&t<="9")return t.charCodeAt(0)-"0".charCodeAt(0);if("A"<=t&&t<="Z")return t.charCodeAt(0)-"A".charCodeAt(0)+10;switch(t){case" ":return 36;case"$":return 37;case"%":return 38;case"*":return 39;case"+":return 40;case"-":return 41;case".":return 42;case"/":return 43;case":":return 44;default:throw"illegal char :"+t}};return n},m=function(r){var e=f,n=t.stringToBytes(r),o={getMode:function(){return e},getLength:function(t){return n.length},write:function(t){for(var r=0;r<n.length;r+=1)t.put(n[r],8)}};return o},L=function(r){var e=c,n=t.stringToBytesFuncs.SJIS;if(!n)throw"sjis not supported.";!function(){var t=n("友");if(2!=t.length||38726!=(t[0]<<8|t[1]))throw"sjis not supported."}();var o=n(r),i={getMode:function(){return e},getLength:function(t){return~~(o.length/2)},write:function(t){for(var r=o,e=0;e+1<r.length;){var n=(255&r[e])<<8|255&r[e+1];if(33088<=n&&n<=40956)n-=33088;else{if(!(57408<=n&&n<=60351))throw"illegal char at "+(e+1)+"/"+n;n-=49472}n=192*(n>>>8&255)+(255&n),t.put(n,13),e+=2}if(e<r.length)throw"illegal char at "+(e+1)}};return i},D=function(){var t=[],r={writeByte:function(r){t.push(255&r)},writeShort:function(t){r.writeByte(t),r.writeByte(t>>>8)},writeBytes:function(t,e,n){e=e||0,n=n||t.length;for(var o=0;o<n;o+=1)r.writeByte(t[o+e])},writeString:function(t){for(var e=0;e<t.length;e+=1)r.writeByte(t.charCodeAt(e))},toByteArray:function(){return t},toString:function(){var r="";r+="[";for(var e=0;e<t.length;e+=1)e>0&&(r+=","),r+=t[e];return r+="]"}};return r},S=function(t){var r=t,e=0,n=0,o=0,i={read:function(){for(;o<8;){if(e>=r.length){if(0==o)return-1;throw"unexpected end of file./"+o}var t=r.charAt(e);if(e+=1,"="==t)return o=0,-1;t.match(/^\s$/)||(n=n<<6|a(t.charCodeAt(0)),o+=6)}var i=n>>>o-8&255;return o-=8,i}},a=function(t){if(65<=t&&t<=90)return t-65;if(97<=t&&t<=122)return t-97+26;if(48<=t&&t<=57)return t-48+52;if(43==t)return 62;if(47==t)return 63;throw"c:"+t};return i},I=function(t,r,e){for(var n=function(t,r){var e=t,n=r,o=new Array(t*r),i={setPixel:function(t,r,n){o[r*e+t]=n},write:function(t){t.writeString("GIF87a"),t.writeShort(e),t.writeShort(n),t.writeByte(128),t.writeByte(0),t.writeByte(0),t.writeByte(0),t.writeByte(0),t.writeByte(0),t.writeByte(255),t.writeByte(255),t.writeByte(255),t.writeString(","),t.writeShort(0),t.writeShort(0),t.writeShort(e),t.writeShort(n),t.writeByte(0);var r=a(2);t.writeByte(2);for(var o=0;r.length-o>255;)t.writeByte(255),t.writeBytes(r,o,255),o+=255;t.writeByte(r.length-o),t.writeBytes(r,o,r.length-o),t.writeByte(0),t.writeString(";")}},a=function(t){for(var r=1<<t,e=1+(1<<t),n=t+1,i=u(),a=0;a<r;a+=1)i.add(String.fromCharCode(a));i.add(String.fromCharCode(r)),i.add(String.fromCharCode(e));var f,c,g,l=D(),h=(f=l,c=0,g=0,{write:function(t,r){if(t>>>r!=0)throw"length over";for(;c+r>=8;)f.writeByte(255&(t<<c|g)),r-=8-c,t>>>=8-c,g=0,c=0;g|=t<<c,c+=r},flush:function(){c>0&&f.writeByte(g)}});h.write(r,n);var s=0,v=String.fromCharCode(o[s]);for(s+=1;s<o.length;){var d=String.fromCharCode(o[s]);s+=1,i.contains(v+d)?v+=d:(h.write(i.indexOf(v),n),i.size()<4095&&(i.size()==1<<n&&(n+=1),i.add(v+d)),v=d)}return h.write(i.indexOf(v),n),h.write(e,n),h.flush(),l.toByteArray()},u=function(){var t={},r=0,e={add:function(n){if(e.contains(n))throw"dup key:"+n;t[n]=r,r+=1},size:function(){return r},indexOf:function(r){return t[r]},contains:function(r){return void 0!==t[r]}};return e};return i}(t,r),o=0;o<r;o+=1)for(var i=0;i<t;i+=1)n.setPixel(i,o,e(i,o));var a=D();n.write(a);for(var u=function(){var t=0,r=0,e=0,n="",o={},i=function(t){n+=String.fromCharCode(a(63&t))},a=function(t){if(t<0);else{if(t<26)return 65+t;if(t<52)return t-26+97;if(t<62)return t-52+48;if(62==t)return 43;if(63==t)return 47}throw"n:"+t};return o.writeByte=function(n){for(t=t<<8|255&n,r+=8,e+=1;r>=6;)i(t>>>r-6),r-=6},o.flush=function(){if(r>0&&(i(t<<6-r),t=0,r=0),e%3!=0)for(var o=3-e%3,a=0;a<o;a+=1)n+="="},o.toString=function(){return n},o}(),f=a.toByteArray(),c=0;c<f.length;c+=1)u.writeByte(f[c]);return u.flush(),"data:image/gif;base64,"+u};return t}();qrcode.stringToBytesFuncs["UTF-8"]=function(t){return function(t){for(var r=[],e=0;e<t.length;e++){var n=t.charCodeAt(e);n<128?r.push(n):n<2048?r.push(192|n>>6,128|63&n):n<55296||n>=57344?r.push(224|n>>12,128|n>>6&63,128|63&n):(e++,n=65536+((1023&n)<<10|1023&t.charCodeAt(e)),r.push(240|n>>18,128|n>>12&63,128|n>>6&63,128|63&n))}return r}(t)},function(t){"function"==typeof define&&define.amd?define([],t):"object"==typeof exports&&(module.exports=t())}(function(){return qrcode});

  /* =========================================================================
     DOWNLOADABLE ROUTINE CARD — 1080 × 1920 PNG drawn on canvas
     (text-only by design: fast, reliable, and legible on a phone)
     ======================================================================= */
  var CARD = {
    w: 1080, h: 1920,
    bg: '#ffffff', soft: '#f8f7f5', ink: '#1d1c1a', muted: '#6f6a63',
    accent: '#fd5f01',        /* brand orange */
    accentDeep: '#c94a00',    /* darker orange for small text */
    blue: '#33b2fe',
    line: '#ebe9e5',
    serif: '"Bodoni Moda", "Bodoni MT", Didot, Georgia, serif',
    sans: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif'
  };

  /* Render a QR code (for AMRB_BRAND.qrUrl) onto a small canvas */
  function qrCanvas(text, size) {
    var qr = qrcode(0, 'M'); /* type 0 = auto-size, error correction M */
    qr.addData(text);
    qr.make();
    var n = qr.getModuleCount();
    var c = document.createElement('canvas');
    c.width = c.height = size;
    var g = c.getContext('2d');
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, size, size);
    g.fillStyle = '#1d1c1a';
    var cell = size / n;
    for (var row = 0; row < n; row++) {
      for (var col = 0; col < n; col++) {
        if (qr.isDark(row, col)) {
          g.fillRect(Math.round(col * cell), Math.round(row * cell), Math.ceil(cell), Math.ceil(cell));
        }
      }
    }
    return c;
  }

  function drawCard() {
    var r = state.result;
    if (!r) return null;
    var canvas = document.createElement('canvas');
    canvas.width = CARD.w; canvas.height = CARD.h;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;

    ctx.fillStyle = CARD.bg;
    ctx.fillRect(0, 0, CARD.w, CARD.h);
    ctx.fillStyle = CARD.soft;
    ctx.fillRect(0, 0, CARD.w, 470);
    ctx.textBaseline = 'alphabetic';

    var cx = CARD.w / 2;

    function tracked(text, y, font, color, spacing, align) {
      ctx.font = font; ctx.fillStyle = color;
      var chars = String(text).split('');
      var widths = chars.map(function (c) { return ctx.measureText(c).width; });
      var total = widths.reduce(function (a, b) { return a + b; }, 0) + spacing * (chars.length - 1);
      var x = (typeof align === 'number') ? align : (align === 'left' ? 90 : cx - total / 2);
      chars.forEach(function (c, i) { ctx.fillText(c, x, y); x += widths[i] + spacing; });
    }
    function center(text, y, font, color) {
      ctx.font = font; ctx.fillStyle = color; ctx.textAlign = 'center';
      ctx.fillText(text, cx, y); ctx.textAlign = 'start';
    }
    function wrap(text, x, y, font, color, maxW, lh, maxLines) {
      ctx.font = font; ctx.fillStyle = color;
      var words = String(text).split(' '), line = '', lines = 0;
      for (var i = 0; i < words.length; i++) {
        var test = line ? line + ' ' + words[i] : words[i];
        if (ctx.measureText(test).width > maxW && line) {
          ctx.fillText(line, x, y); y += lh; lines += 1; line = words[i];
          if (maxLines && lines >= maxLines - 1) { line += '…'; break; }
        } else { line = test; }
      }
      ctx.fillText(line, x, y);
      return y + lh;
    }
    function rule(y, w2, color) {
      ctx.fillStyle = color || CARD.line;
      ctx.fillRect(cx - w2 / 2, y, w2, 2);
    }

    /* ---- header ---- */
    tracked(AMRB_BRAND.name, 120, '600 30px ' + CARD.sans, CARD.ink, 9);
    rule(160, 56, CARD.accent);
    tracked(AMRB_BRAND.resultTitle, 280, '500 104px ' + CARD.serif, CARD.ink, 6);
    center(AMRB_BRAND.resultTagline, 340, 'italic 33px ' + CARD.serif, CARD.muted);
    var dateStr = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    tracked(dateStr.toUpperCase(), 395, '400 22px ' + CARD.sans, CARD.muted, 3);
    var goals = (state.answers.goals || []).map(goalLabel);
    if (goals.length) {
      tracked(goals.join('  ·  ').toUpperCase(), 442, '500 21px ' + CARD.sans, CARD.accent, 2);
    }

    /* ---- routines ---- */
    var y = 560;
    var maxY = 1400; /* keep clear of the QR / promo footer */

    function routineBlock(label, theme, steps) {
      tracked(label.toUpperCase(), y, '700 26px ' + CARD.sans, CARD.ink, 6); y += 40;
      tracked(theme.toUpperCase(), y, '500 21px ' + CARD.sans, CARD.accent, 3); y += 44;
      if (!steps.length) {
        ctx.font = 'italic 26px ' + CARD.serif; ctx.fillStyle = CARD.muted;
        ctx.fillText('See recommendations at ' + AMRB_BRAND.site, 90, y); y += 52;
      }
      var shown = 0;
      for (var i = 0; i < steps.length; i++) {
        if (y > maxY - 60) {
          ctx.font = '400 24px ' + CARD.sans; ctx.fillStyle = CARD.muted;
          ctx.fillText('+ ' + (steps.length - shown) + ' more — see full routine online', 90, y);
          y += 44; return;
        }
        var s = steps[i];
        var num = (i + 1 < 10 ? '0' : '') + (i + 1);
        ctx.font = '500 30px ' + CARD.serif; ctx.fillStyle = CARD.accent;
        ctx.fillText(num, 90, y);
        ctx.font = '500 30px ' + CARD.sans; ctx.fillStyle = CARD.ink;
        var name = s.name.length > 46 ? s.name.slice(0, 45) + '…' : s.name;
        ctx.fillText(name, 160, y);
        y += 38;
        var slotLabel = '';
        for (var li = 0; li < AMRB_LAYERS.length; li++) { if (AMRB_LAYERS[li].key === s.slot) slotLabel = AMRB_LAYERS[li].label; }
        var meta = slotLabel.toUpperCase() + (s.freq ? '  ·  ' + s.freq : '');
        if (meta.length > 74) meta = meta.slice(0, 73) + '…';
        ctx.font = '400 22px ' + CARD.sans; ctx.fillStyle = CARD.muted;
        ctx.fillText(meta, 160, y);
        y += 44;
        shown += 1;
      }
      y += 18;
    }

    routineBlock('Good Morning — AM', r.amTheme, r.am);
    rule(y - 8, CARD.w - 180); y += 46;
    routineBlock('Good Night — PM', r.pmTheme, r.pm);

    /* ---- key notes ---- */
    var notes = r.insights.slice(0, 2);
    if (notes.length && y < maxY + 40) {
      rule(y - 8, CARD.w - 180); y += 46;
      tracked('KEY NOTES', y, '700 24px ' + CARD.sans, CARD.ink, 5); y += 40;
      notes.forEach(function (n) {
        if (y > 1470) return;
        y = wrap('· ' + n, 90, y, '400 24px ' + CARD.sans, CARD.muted, CARD.w - 180, 34, 2) + 8;
      });
    }

    /* ---- recommendations ---- */
    if (r.recs.length && y < 1500) {
      tracked('FROM THE A METHOD®', y, '700 24px ' + CARD.sans, CARD.accentDeep, 5); y += 40;
      var names = r.recs.map(function (rec) { return rec.product.name; }).join('  ·  ');
      y = wrap(names, 90, y, '400 24px ' + CARD.sans, CARD.ink, CARD.w - 180, 34, 2);
    }

    /* ---- footer: QR code + promo + site ---- */
    ctx.fillStyle = CARD.soft;
    ctx.fillRect(0, 1560, CARD.w, CARD.h - 1560);
    var qrOk = false;
    try {
      var qc = qrCanvas(AMRB_BRAND.qrUrl, 440);
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(90, 1600, 240, 240);
      ctx.drawImage(qc, 104, 1614, 212, 212);
      qrOk = true;
    } catch (e) { /* QR unavailable — text promo still renders */ }
    var tx = qrOk ? 375 : 90;
    var tw = CARD.w - tx - 90;
    tracked('SCAN TO SHOP', 1655, '700 25px ' + CARD.sans, CARD.accentDeep, 6, tx);
    ctx.font = '600 46px ' + CARD.serif; ctx.fillStyle = CARD.ink;
    ctx.fillText(AMRB_BRAND.promoCode, tx, 1715);
    wrap(AMRB_BRAND.promoLine2 + ' at ' + AMRB_BRAND.site + '.', tx, 1762, '400 24px ' + CARD.sans, CARD.muted, tw, 34, 3);
    tracked(AMRB_BRAND.site.toUpperCase(), 1878, '600 24px ' + CARD.sans, CARD.ink, 6);
    center('Skincare education — not a substitute for medical advice.', 1908, '400 18px ' + CARD.sans, CARD.muted);

    return canvas;
  }

  function saveMsg(text) {
    var el = mount.querySelector('[data-amrb-save-msg]');
    if (el) { el.textContent = text; el.hidden = false; }
  }

  function downloadCard() {
    /* Wait for Poppins / Bodoni Moda webfonts so the card uses brand type */
    if (document.fonts && document.fonts.ready && !downloadCard._fontsReady) {
      var kicked = false;
      var done = function () { if (kicked) return; kicked = true; downloadCard._fontsReady = true; downloadCard(); };
      document.fonts.ready.then(done, done);
      window.setTimeout(done, 1500);
      return;
    }
    try {
      var canvas = drawCard();
      if (!canvas) throw new Error('no canvas');
      var url = canvas.toDataURL('image/png');
      var a = document.createElement('a');
      a.href = url;
      a.download = 'my-method-theamethod.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      saveMsg('Routine card downloaded. On a phone, it may open in a new tab — press and hold to save it to your photos.');
    } catch (e) {
      saveMsg('Direct download isn’t available in this browser — opening the print view instead.');
      printCard();
    }
  }

  /* =========================================================================
     PRINT / PDF VIEW — mobile-formatted, exports cleanly via the browser
     ======================================================================= */
  function printCard() {
    var r = state.result;
    if (!r) return;
    var goals = (state.answers.goals || []).map(goalLabel);
    var dateStr = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });

    function stepsHtml(steps) {
      if (!steps.length) return '<p class="empty">See recommendations at ' + esc(AMRB_BRAND.site) + '</p>';
      return steps.map(function (s, i) {
        var slotLabel = '';
        for (var li = 0; li < AMRB_LAYERS.length; li++) { if (AMRB_LAYERS[li].key === s.slot) slotLabel = AMRB_LAYERS[li].label; }
        return '<div class="step"><span class="num">' + (i + 1 < 10 ? '0' : '') + (i + 1) + '</span>' +
          '<div><div class="pname">' + esc(s.name) + '</div>' +
          '<div class="pmeta">' + esc(slotLabel.toUpperCase()) + (s.freq ? ' · ' + esc(s.freq) : '') + '</div></div></div>';
      }).join('');
    }

    /* QR for the print view (data URL, generated locally) */
    var qrDataUrl = '';
    try { qrDataUrl = qrCanvas(AMRB_BRAND.qrUrl, 300).toDataURL('image/png'); } catch (e) { /* text promo only */ }

    var html = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>My Method — The A Method®</title>' +
      '<meta name="viewport" content="width=device-width, initial-scale=1">' +
      '<style>' +
      '@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,600;1,6..96,400&display=swap");' +
      'body{font-family:Poppins,"Helvetica Neue",Helvetica,Arial,sans-serif;color:#1d1c1a;margin:0;padding:34px 26px;max-width:430px;margin:0 auto;}' +
      'h1{font-family:"Bodoni Moda",Didot,Georgia,serif;font-weight:500;font-size:38px;letter-spacing:.04em;text-align:center;margin:8px 0 2px;}' +
      '.brand{letter-spacing:.28em;font-size:12px;font-weight:600;text-align:center;margin-top:10px;}' +
      '.tag{font-family:"Bodoni Moda",Didot,Georgia,serif;font-style:italic;color:#6f6a63;text-align:center;margin:0 0 6px;}' +
      '.date,.goals{text-align:center;font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#6f6a63;margin:4px 0;}' +
      '.goals{color:#c94a00;}' +
      'h2{font-size:13px;letter-spacing:.22em;text-transform:uppercase;border-top:1px solid #ebe9e5;padding-top:18px;margin:26px 0 4px;}' +
      '.theme{font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#c94a00;margin:0 0 12px;}' +
      '.step{display:flex;gap:14px;margin:0 0 12px;}' +
      '.num{font-family:"Bodoni Moda",Didot,Georgia,serif;color:#fd5f01;font-size:17px;min-width:26px;}' +
      '.pname{font-weight:500;font-size:15px;}' +
      '.pmeta{font-size:11.5px;color:#6f6a63;letter-spacing:.04em;}' +
      '.notes{font-size:12.5px;color:#6f6a63;border-top:1px solid #ebe9e5;padding-top:14px;margin-top:22px;}' +
      '.recs{font-size:12.5px;margin-top:10px;}' +
      '.promo{text-align:center;border-top:1px solid #ebe9e5;margin-top:24px;padding-top:20px;}' +
      '.promo img{display:block;margin:0 auto 10px;width:140px;height:140px;}' +
      '.promo-eyebrow{font-size:11px;letter-spacing:.24em;text-transform:uppercase;color:#c94a00;font-weight:600;}' +
      '.promo-code{font-family:"Bodoni Moda",Didot,Georgia,serif;font-size:28px;letter-spacing:.06em;margin:4px 0 2px;}' +
      '.promo-text{font-size:12px;color:#6f6a63;}' +
      '.foot{margin-top:24px;text-align:center;font-size:11px;letter-spacing:.2em;text-transform:uppercase;}' +
      '.disc{font-size:10px;color:#6f6a63;text-align:center;margin-top:8px;letter-spacing:0;text-transform:none;}' +
      '.empty{font-size:13px;color:#6f6a63;font-style:italic;}' +
      '@media print{body{padding:12px;}}' +
      '</style></head><body>' +
      '<p class="brand">' + esc(AMRB_BRAND.name) + '</p>' +
      '<h1>' + esc(AMRB_BRAND.resultTitle) + '</h1>' +
      '<p class="tag">' + esc(AMRB_BRAND.resultTagline) + '</p>' +
      '<p class="date">' + esc(dateStr) + '</p>' +
      (goals.length ? '<p class="goals">' + esc(goals.join(' · ')) + '</p>' : '') +
      '<h2>Good Morning — AM</h2><p class="theme">' + esc(r.amTheme) + '</p>' + stepsHtml(r.am) +
      '<h2>Good Night — PM</h2><p class="theme">' + esc(r.pmTheme) + '</p>' + stepsHtml(r.pm) +
      (r.weekly.length ? '<p class="notes"><strong>Weekly:</strong> ' + r.weekly.map(function (w) { return esc(w.name) + ' — ' + esc(w.note); }).join(' · ') + '</p>' : '') +
      (r.insights.length ? '<div class="notes"><strong>Key notes</strong><br>' + r.insights.slice(0, 3).map(esc).join('<br>') + '</div>' : '') +
      (r.recs.length ? '<p class="recs"><strong>From ' + esc(AMRB_BRAND.name) + ':</strong> ' + r.recs.map(function (rec) { return esc(rec.product.name); }).join(' · ') + '</p>' : '') +
      '<div class="promo">' +
        (qrDataUrl ? '<img src="' + qrDataUrl + '" alt="QR code — shop The A Method with code ' + esc(AMRB_BRAND.promoCode) + '">' : '') +
        '<div class="promo-eyebrow">Scan to shop</div>' +
        '<div class="promo-code">' + esc(AMRB_BRAND.promoCode) + '</div>' +
        '<div class="promo-text">' + esc(AMRB_BRAND.promoLine2) + ' at ' + esc(AMRB_BRAND.site) + '</div>' +
      '</div>' +
      '<p class="foot">' + esc(AMRB_BRAND.site) + '</p>' +
      '<p class="disc">' + esc(AMRB_BRAND.disclaimer) + '</p>' +
      '</body></html>';

    var win = window.open('', '_blank');
    if (!win) {
      saveMsg('Your browser blocked the print window — please allow pop-ups for this site and try again.');
      return;
    }
    win.document.open();
    win.document.write(html);
    win.document.close();
    win.focus();
    window.setTimeout(function () { try { win.print(); } catch (e) { /* user can print manually */ } }, 400);
  }

  /* =========================================================================
     INIT
     ======================================================================= */
  function init() {
    /* Educational stack in the static intro section */
    buildStack(ROOT.querySelector('[data-amrb-stack]'), 'i');

    /* Start button */
    var startBtn = ROOT.querySelector('[data-amrb-start]');
    if (startBtn) startBtn.addEventListener('click', function () {
      state.view = 'quiz';
      state.qIndex = 0;
      render();
      var app = ROOT.querySelector('.amrb-app');
      if (app) app.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Saved routine? Offer to resume. */
    var saved = store.get();
    if (saved && saved.answers && saved.answers.goals && saved.answers.goals.length) {
      var resumeWrap = ROOT.querySelector('[data-amrb-resume]');
      var resumeBtn = ROOT.querySelector('[data-amrb-resume-btn]');
      if (resumeWrap && resumeBtn) {
        resumeWrap.hidden = false;
        resumeBtn.addEventListener('click', function () {
          state.answers = saved.answers || {};
          state.shelf = saved.shelf || [];
          state.view = 'analyzing';
          render();
          var app = ROOT.querySelector('.amrb-app');
          if (app) app.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
